// import React, { useState, useEffect } from 'react';
// import {
//     RefreshCw,
//     Cloud,
//     CheckCircle,
//     AlertCircle,
//     Upload,
//     Activity,
//     Edit2,
//     X,
//     Calculator,
//     Brain,
//     Target,
//     CreditCard,
//     User,
//     Building,
//     Calendar,
//     Info,
//     AlertTriangle,
//     Filter,
//     Eye,
//     Plus,
//     Trash2
// } from 'lucide-react';

// const DailySpendZohoIntegration = () => {
//     const [syncStatus, setSyncStatus] = useState(null);
//     const [expenses, setExpenses] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [syncInProgress, setSyncInProgress] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [editingExpense, setEditingExpense] = useState(null);
//     const [statusFilter, setStatusFilter] = useState('all');

//     // Pagination
//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         total: 0,
//         totalPages: 0
//     });

//     // Edit form state
//     const [editForm, setEditForm] = useState({
//         nature_of_expenses: '',
//         amount: 0,
//         date: '',
//         line_items: [],
//         is_cash_payment: false,
//         employee_details: null,
//         ai_suggestions: null,
//         config_options: null
//     });

//     // Sync configuration for the current expense
//     const [expenseSyncConfig, setExpenseSyncConfig] = useState({
//         expense_account_id: '',
//         payment_account_id: '',
//         paid_through_account_id: '',
//         tax_id: '',
//         gst_treatment: 'business_none',
//         source_of_supply: 'TN',
//         destination_of_supply: 'TN',
//         is_inclusive_tax: false,
//         invoice_no: '',
//         notes: '',
//         expense_type: 'service',
//         is_reverse_charge: false
//     });

//     const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

//     // Get authentication headers
//     const getAuthHeaders = () => {
//         const token = localStorage.getItem('authToken') || localStorage.getItem('auth_token') || localStorage.getItem('token');
//         return {
//             'Content-Type': 'application/json',
//             ...(token && { 'Authorization': `Bearer ${token}` })
//         };
//     };

//     useEffect(() => {
//         fetchSyncStatus();
//         fetchExpenses();
//     }, []);

//     useEffect(() => {
//         fetchExpenses();
//     }, [pagination.page, statusFilter]);

//     const fetchSyncStatus = async () => {
//         try {
//             const response = await fetch(`${API_BASE_URL}/zoho/sync-status`, {
//                 headers: getAuthHeaders()
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setSyncStatus(data.data);
//             }
//         } catch (error) {
//             console.error('Error fetching sync status:', error);
//         }
//     };

//     const fetchExpenses = async () => {
//         try {
//             setLoading(true);
//             const params = new URLSearchParams({
//                 limit: pagination.limit.toString(),
//                 page: pagination.page.toString()
//             });

//             if (statusFilter !== 'all') {
//                 params.append('status_filter', statusFilter);
//             }

//             const response = await fetch(`${API_BASE_URL}/zoho/expenses?${params}`, {
//                 headers: getAuthHeaders()
//             });
//             const data = await response.json();
//             if (data.success) {
//                 setExpenses(data.data);
//                 if (data.pagination) {
//                     setPagination(prev => ({
//                         ...prev,
//                         total: data.pagination.total,
//                         totalPages: data.pagination.totalPages
//                     }));
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching expenses:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fixed date formatting function
//     const formatDateForInput = (dateString) => {
//         if (!dateString) return '';

//         if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
//             return dateString;
//         }

//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) {
//                 return '';
//             }

//             const year = date.getFullYear();
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const day = String(date.getDate()).padStart(2, '0');

//             return `${year}-${month}-${day}`;
//         } catch (error) {
//             return '';
//         }
//     };

//     const generateInvoiceNumber = (expenseId) => {
//         const paddedId = String(expenseId).padStart(4, '0');
//         return `EXP-${paddedId}`;
//     };

//     // Enhanced handleEditExpense function with better line item handling
//     const handleEditExpense = async (expense) => {
//         setEditingExpense(expense);

//         try {
//             const response = await fetch(`${API_BASE_URL}/zoho/expense-details/${expense.id}`, {
//                 headers: getAuthHeaders()
//             });
//             const data = await response.json();

//             if (data.success) {
//                 const expenseDetails = data.data;

//                 // Enhanced line item handling with proper AI suggestions
//                 let lineItems = [];

//                 if (expenseDetails.suggested_line_items && expenseDetails.suggested_line_items.length > 0) {
//                     // Use AI-suggested line items
//                     lineItems = expenseDetails.suggested_line_items.map((item, index) => ({
//                         id: item.id || `line_${index}`,
//                         description: item.description || '',
//                         amount: parseFloat(item.amount) || 0,
//                         expense_type: item.expense_type || 'service',
//                         account_id: item.account_id || '',
//                         suggested_account_name: item.suggested_account_name || '',
//                         ai_confidence: item.ai_confidence || 0,
//                         ai_suggested: true,
//                         original_text: item.original_text || ''
//                     }));
//                 } else if (expenseDetails.line_items && expenseDetails.line_items.length > 0) {
//                     // Use existing line items
//                     lineItems = expenseDetails.line_items.map((item, index) => ({
//                         id: item.id || `line_${index}`,
//                         description: item.description || '',
//                         amount: parseFloat(item.amount) || 0,
//                         expense_type: item.expense_type || 'service',
//                         account_id: item.account_id || '',
//                         suggested_account_name: '',
//                         ai_confidence: 0,
//                         ai_suggested: false
//                     }));
//                 } else {
//                     // Create a single line item from the main expense
//                     lineItems = [{
//                         id: 'line_0',
//                         description: expenseDetails.nature_of_expenses || 'General Expense',
//                         amount: parseFloat(expenseDetails.amount) || 0,
//                         expense_type: 'service',
//                         account_id: expenseDetails.ai_suggestions?.expense_account?.account_id || '',
//                         suggested_account_name: expenseDetails.ai_suggestions?.expense_account?.account_name || '',
//                         ai_confidence: expenseDetails.ai_suggestions?.expense_account?.confidence || 0,
//                         ai_suggested: !!expenseDetails.ai_suggestions?.expense_account
//                     }];
//                 }

//                 // Set form data with enhanced line items
//                 setEditForm({
//                     nature_of_expenses: expenseDetails.nature_of_expenses || '',
//                     amount: expenseDetails.amount || 0,
//                     date: formatDateForInput(expenseDetails.date),
//                     line_items: lineItems,
//                     is_cash_payment: expenseDetails.is_cash_payment || false,
//                     employee_details: expenseDetails.employee_details || null,
//                     ai_suggestions: expenseDetails.ai_suggestions || null,
//                     config_options: expenseDetails.config_options || null
//                 });

//                 // Set sync configuration with AI suggestions
//                 const defaultConfig = {
//                     invoice_no: generateInvoiceNumber(expenseDetails.id),
//                     expense_account_id: lineItems.length > 0 ? lineItems[0].account_id : '',
//                     payment_account_id: expenseDetails.ai_suggestions?.payment_account?.account_id || '',
//                     paid_through_account_id: expenseDetails.ai_suggestions?.payment_account?.account_id || '',
//                     expense_type: 'service',
//                     gst_treatment: expenseDetails.is_cash_payment ? 'business_none' : 'business_none',
//                     source_of_supply: 'TN',
//                     destination_of_supply: 'TN',
//                     notes: expenseDetails.is_cash_payment && expenseDetails.employee_details ?
//                         `Cash payment by employee: ${expenseDetails.employee_details.name}` : ''
//                 };

//                 setExpenseSyncConfig(defaultConfig);
//             }
//         } catch (error) {
//             console.error('Error fetching expense details:', error);
//         }

//         setShowEditModal(true);
//     };

//     // Enhanced line item change handler
//     const handleLineItemChange = (index, field, value) => {
//         setEditForm(prev => ({
//             ...prev,
//             line_items: prev.line_items.map((item, i) =>
//                 i === index ? { ...item, [field]: value } : item
//             )
//         }));
//     };

//     // Add new line item
//     const addLineItem = () => {
//         const newItem = {
//             id: `line_${Date.now()}`,
//             description: '',
//             amount: 0,
//             expense_type: 'service',
//             account_id: '',
//             suggested_account_name: '',
//             ai_confidence: 0,
//             ai_suggested: false
//         };

//         setEditForm(prev => ({
//             ...prev,
//             line_items: [...prev.line_items, newItem]
//         }));
//     };

//     // Remove line item
//     const removeLineItem = (index) => {
//         if (editForm.line_items.length > 1) {
//             setEditForm(prev => ({
//                 ...prev,
//                 line_items: prev.line_items.filter((_, i) => i !== index)
//             }));
//         }
//     };

//     // Enhanced line item account change handler with debugging
//     const handleLineItemAccountChange = (index, accountId) => {
//         console.log(`Changing account for item ${index} to:`, accountId);

//         setEditForm(prev => {
//             const updatedLineItems = prev.line_items.map((item, i) =>
//                 i === index ? {
//                     ...item,
//                     account_id: accountId,
//                     // Mark as manually overridden if it was AI suggested
//                     manually_selected: item.ai_suggested && accountId !== item.account_id
//                 } : item
//             );

//             console.log('Updated line items:', updatedLineItems);

//             return {
//                 ...prev,
//                 line_items: updatedLineItems
//             };
//         });
//     };

//     const calculateTotalAmount = () => {
//         return editForm.line_items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
//     };

//     // Enhanced sync expense function with proper line item handling
//     const handleSyncExpense = async () => {
//         try {
//             setSyncInProgress(true);

//             // Enhanced validation for itemized expenses
//             const invalidItems = editForm.line_items.filter(item => !item.account_id || !item.description.trim());
//             if (invalidItems.length > 0) {
//                 alert(`Please complete all line items. ${invalidItems.length} items are missing account selection or description.`);
//                 return;
//             }

//             const zeroAmountItems = editForm.line_items.filter(item => parseFloat(item.amount) <= 0);
//             if (zeroAmountItems.length > 0) {
//                 alert('All line items must have amounts greater than zero.');
//                 return;
//             }

//             if (!editForm.is_cash_payment && !expenseSyncConfig.paid_through_account_id) {
//                 alert('Please select a payment account for bank payments');
//                 return;
//             }

//             // Prepare sync configuration with detailed line items
//             const syncConfig = {
//                 ...expenseSyncConfig,
//                 line_items: editForm.line_items.map(item => ({
//                     description: item.description.trim(),
//                     amount: parseFloat(item.amount),
//                     account_id: item.account_id,
//                     expense_type: item.expense_type || 'service',
//                     ai_suggested: item.ai_suggested || false,
//                     ai_confidence: item.ai_confidence || 0,
//                     manually_selected: item.manually_selected || false
//                 })),
//                 date: editForm.date,
//                 custom_amount: calculateTotalAmount(),
//                 total_line_items: editForm.line_items.length,
//                 has_ai_suggestions: editForm.line_items.some(item => item.ai_suggested),
//                 nature_of_expenses: editForm.nature_of_expenses
//             };

//             console.log('Syncing with config:', syncConfig);

//             const response = await fetch(`${API_BASE_URL}/zoho/sync-expense/${editingExpense.id}`, {
//                 method: 'POST',
//                 headers: getAuthHeaders(),
//                 body: JSON.stringify(syncConfig)
//             });

//             const data = await response.json();

//             if (data.success) {
//                 alert(data.message || 'Expense synced successfully!');
//                 setShowEditModal(false);
//                 setEditingExpense(null);
//                 fetchSyncStatus();
//                 fetchExpenses();
//             } else {
//                 // Enhanced error handling for approval status
//                 if (data.approval_status) {
//                     let alertMessage = data.message;

//                     if (data.approval_status === 'pending_approval' && data.approver_details) {
//                         alertMessage += `\n\nApprover: ${data.approver_details.name || 'Unknown'}`;
//                         if (data.approver_details.whatsapp) {
//                             alertMessage += `\nWhatsApp: ${data.approver_details.whatsapp}`;
//                         }
//                         if (data.approver_details.email) {
//                             alertMessage += `\nEmail: ${data.approver_details.email}`;
//                         }
//                     }

//                     if (data.approval_status === 'rejected' && data.rejection_reason) {
//                         alertMessage += `\n\nRejection Reason: ${data.rejection_reason}`;
//                     }

//                     alert(alertMessage);
//                 } else {
//                     alert(`Failed to sync expense: ${data.message || 'Unknown error'}`);
//                 }
//             }
//         } catch (error) {
//             console.error('Error syncing expense:', error);
//             alert('Failed to sync expense. Please check your connection and try again.');
//         } finally {
//             setSyncInProgress(false);
//         }
//     };

//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-IN', {
//             style: 'currency',
//             currency: 'INR'
//         }).format(amount || 0);
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return 'Never';
//         return new Date(dateString).toLocaleDateString('en-IN');
//     };

//     // Helper function to get payment mode display
//     const getPaymentModeDisplay = (expense) => {
//         const mode = expense.mode_of_payment ? expense.mode_of_payment.toLowerCase() : 'bank';

//         if (mode === 'cash') {
//             return {
//                 icon: User,
//                 color: 'text-green-600',
//                 label: 'Cash',
//                 bgColor: 'bg-green-50',
//                 syncAs: 'Bill',
//                 requiresEmployee: true
//             };
//         } else {
//             return {
//                 icon: CreditCard,
//                 color: 'text-blue-600',
//                 label: 'Bank/Card',
//                 bgColor: 'bg-blue-50',
//                 syncAs: 'Expense',
//                 requiresEmployee: false
//             };
//         }
//     };

//     const handleStatusFilterClick = (filter) => {
//         setStatusFilter(filter);
//         setPagination(prev => ({ ...prev, page: 1 }));
//     };

//     // Get AI suggestion indicator for line items
//     const getAISuggestionIndicator = (item) => {
//         if (!item.ai_suggested) return null;

//         const confidenceLevel = item.ai_confidence * 100;
//         let color = 'text-purple-600';
//         let bgColor = 'bg-purple-100';

//         if (confidenceLevel >= 80) {
//             color = 'text-green-600';
//             bgColor = 'bg-green-100';
//         } else if (confidenceLevel >= 60) {
//             color = 'text-yellow-600';
//             bgColor = 'bg-yellow-100';
//         }

//         return (
//             <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${bgColor} ${color}`}>
//                 <Brain size={10} className="mr-1" />
//                 AI: {Math.round(confidenceLevel)}%
//             </span>
//         );
//     };

//     // Enhanced function to handle manual AI suggestions with proper dropdown setting
//     const handleManualAISuggestion = async () => {
//         if (!editingExpense) return;

//         try {
//             setLoading(true);
//             console.log('Requesting AI suggestions for expense:', editingExpense.id);

//             const response = await fetch(`${API_BASE_URL}/zoho/expense-details/${editingExpense.id}?force_ai_suggestions=true`, {
//                 headers: getAuthHeaders()
//             });
//             const data = await response.json();

//             if (data.success) {
//                 const expenseDetails = data.data;
//                 console.log('Received AI suggestions:', expenseDetails.ai_suggestions);
//                 console.log('Updated line items:', expenseDetails.suggested_line_items);

//                 // Update line items with new AI suggestions and ensure account_id is properly set
//                 if (expenseDetails.suggested_line_items) {
//                     const updatedLineItems = expenseDetails.suggested_line_items.map(item => ({
//                         ...item,
//                         // Ensure account_id is properly set for dropdown
//                         account_id: item.account_id || '',
//                         ai_suggested: item.ai_suggested || false,
//                         ai_confidence: item.ai_confidence || 0,
//                         suggested_account_name: item.suggested_account_name || ''
//                     }));

//                     console.log('Setting updated line items:', updatedLineItems);

//                     setEditForm(prev => ({
//                         ...prev,
//                         line_items: updatedLineItems,
//                         ai_suggestions: expenseDetails.ai_suggestions
//                     }));

//                     // Update sync config with first item's account if available
//                     if (updatedLineItems.length > 0 && updatedLineItems[0].account_id) {
//                         setExpenseSyncConfig(prev => ({
//                             ...prev,
//                             expense_account_id: updatedLineItems[0].account_id
//                         }));
//                     }

//                     const successCount = updatedLineItems.filter(item => item.ai_suggested && item.account_id).length;
//                     alert(`AI suggestions applied! ${successCount} out of ${updatedLineItems.length} items got account suggestions.`);
//                 } else {
//                     alert('No line items received from AI suggestions.');
//                 }
//             } else {
//                 alert('Failed to get AI suggestions: ' + data.message);
//             }
//         } catch (error) {
//             console.error('Error getting AI suggestions:', error);
//             alert('Failed to get AI suggestions. Please try again.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="max-w-7xl mx-auto p-6 space-y-6">
//             {/* Header */}
//             <div className="flex justify-between items-center">
//                 <div>
//                     <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-2">
//                         <Cloud className="text-blue-600" size={32} />
//                         AI-Powered Zoho Integration
//                     </h1>
//                     <p className="text-gray-600 mt-1">
//                         Individual expense validation with AI suggestions - Line-by-line itemization
//                     </p>
//                 </div>
//                 <button
//                     onClick={() => {
//                         fetchSyncStatus();
//                         fetchExpenses();
//                     }}
//                     disabled={loading}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2"
//                 >
//                     <RefreshCw className={loading ? 'animate-spin' : ''} size={16} />
//                     Refresh
//                 </button>
//             </div>

//             {/* AI Features Banner */}
//             {/* <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-4 rounded-lg border border-purple-200">
//                 <div className="flex items-center gap-2 mb-2">
//                     <Brain className="text-purple-600" size={20} />
//                     <h3 className="font-medium text-purple-900">AI-Powered Features</h3>
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
//                     <div className="flex items-center gap-2">
//                         <Target className="text-purple-500" size={14} />
//                         <span className="text-purple-800">OpenAI line-item expense suggestions</span>
//                     </div>
//                     <div className="flex items-center gap-2">
//                         <CreditCard className="text-blue-500" size={14} />
//                         <span className="text-purple-800">Smart bank account validation</span>
//                     </div>
//                     <div className="flex items-center gap-2">
//                         <User className="text-green-500" size={14} />
//                         <span className="text-purple-800">Auto employee vendor creation</span>
//                     </div>
//                 </div>
//             </div> */}

//             {/* Enhanced Sync Status Dashboard - Clickable */}
//             {syncStatus && (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
//                     <div
//                         className="bg-white p-4 rounded-lg shadow border cursor-pointer hover:shadow-md transition-shadow"
//                         onClick={() => handleStatusFilterClick('all')}
//                     >
//                         <div className="flex items-center gap-2 mb-2">
//                             <Activity className={`${statusFilter === 'all' ? 'text-blue-600' : 'text-blue-500'}`} size={20} />
//                             <h3 className="font-medium text-gray-900">Total Expenses</h3>
//                         </div>
//                         <div className="text-2xl font-bold text-gray-900">{syncStatus.total_expenses}</div>
//                         {statusFilter === 'all' && (
//                             <div className="text-xs text-blue-600 font-medium mt-1">Currently viewing</div>
//                         )}
//                     </div>

//                     <div
//                         className="bg-white p-4 rounded-lg shadow border cursor-pointer hover:shadow-md transition-shadow"
//                         onClick={() => handleStatusFilterClick('synced')}
//                     >
//                         <div className="flex items-center gap-2 mb-2">
//                             <CheckCircle className={`${statusFilter === 'synced' ? 'text-green-600' : 'text-green-500'}`} size={20} />
//                             <h3 className="font-medium text-gray-900">Synced</h3>
//                         </div>
//                         <div className="text-2xl font-bold text-green-600">{syncStatus.synced_expenses}</div>
//                         <div className="text-xs text-gray-500 mt-1">
//                             {syncStatus.cash_bills_synced || 0} bills + {syncStatus.bank_expenses_synced || 0} expenses
//                         </div>
//                         {statusFilter === 'synced' && (
//                             <div className="text-xs text-green-600 font-medium mt-1">Currently viewing</div>
//                         )}
//                     </div>

//                     <div
//                         className="bg-white p-4 rounded-lg shadow border cursor-pointer hover:shadow-md transition-shadow"
//                         onClick={() => handleStatusFilterClick('unsynced')}
//                     >
//                         <div className="flex items-center gap-2 mb-2">
//                             <AlertCircle className={`${statusFilter === 'unsynced' ? 'text-orange-600' : 'text-orange-500'}`} size={20} />
//                             <h3 className="font-medium text-gray-900">Pending</h3>
//                         </div>
//                         <div className="text-2xl font-bold text-orange-600">{syncStatus.unsynced_expenses}</div>
//                         <div className="text-xs text-orange-600 mt-1">Requires validation</div>
//                         {statusFilter === 'unsynced' && (
//                             <div className="text-xs text-orange-600 font-medium mt-1">Currently viewing</div>
//                         )}
//                     </div>

//                     <div
//                         className="bg-white p-4 rounded-lg shadow border cursor-pointer hover:shadow-md transition-shadow"
//                         onClick={() => handleStatusFilterClick('cash')}
//                     >
//                         <div className="flex items-center gap-2 mb-2">
//                             <User className={`${statusFilter === 'cash' ? 'text-green-600' : 'text-green-500'}`} size={20} />
//                             <h3 className="font-medium text-gray-900">Cash Payments</h3>
//                         </div>
//                         <div className="text-2xl font-bold text-green-600">{syncStatus.cash_payments || 0}</div>
//                         <div className="text-xs text-gray-500 mt-1">Will sync as bills</div>
//                         {statusFilter === 'cash' && (
//                             <div className="text-xs text-green-600 font-medium mt-1">Currently viewing</div>
//                         )}
//                     </div>

//                     <div
//                         className="bg-white p-4 rounded-lg shadow border cursor-pointer hover:shadow-md transition-shadow"
//                         onClick={() => handleStatusFilterClick('bank')}
//                     >
//                         <div className="flex items-center gap-2 mb-2">
//                             <CreditCard className={`${statusFilter === 'bank' ? 'text-blue-600' : 'text-blue-500'}`} size={20} />
//                             <h3 className="font-medium text-gray-900">Bank Payments</h3>
//                         </div>
//                         <div className="text-2xl font-bold text-blue-600">{syncStatus.bank_payments || 0}</div>
//                         <div className="text-xs text-gray-500 mt-1">Will sync as expenses</div>
//                         {statusFilter === 'bank' && (
//                             <div className="text-xs text-blue-600 font-medium mt-1">Currently viewing</div>
//                         )}
//                     </div>
//                 </div>
//             )}

//             {/* Active Filter Display */}
//             {statusFilter !== 'all' && (
//                 <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                         <Filter className="text-blue-600" size={16} />
//                         <span className="text-blue-800 font-medium">
//                             Currently viewing: {statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)} expenses
//                         </span>
//                     </div>
//                     <button
//                         onClick={() => handleStatusFilterClick('all')}
//                         className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//                     >
//                         Clear filter
//                     </button>
//                 </div>
//             )}

//             {/* Expenses Table with AI Suggestions */}
//             <div className="bg-white rounded-lg shadow border">
//                 <div className="p-6 border-b">
//                     <div className="flex justify-between items-center">
//                         <div>
//                             <h3 className="text-lg font-semibold flex items-center gap-2">
//                                 <Brain className="text-purple-500" size={20} />
//                                 Expenses with AI-Powered Line Item Validation
//                             </h3>
//                             <p className="text-sm text-gray-600">
//                                 Each expense requires individual validation with AI suggestions for each line item
//                             </p>
//                         </div>
//                         <div className="text-sm text-gray-500">
//                             Showing {expenses.length} of {pagination.total} expenses
//                         </div>
//                     </div>
//                 </div>

//                 <div className="overflow-x-auto">
//                     <table className="min-w-full divide-y divide-gray-200">
//                         <thead className="bg-gray-50">
//                             <tr>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Date & Description
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Payment Mode & Employee
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     AI Suggestions & Line Items
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Amount & Status
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Approval Status
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Actions
//                                 </th>
//                             </tr>
//                         </thead>
//                         <tbody className="bg-white divide-y divide-gray-200">
//                             {loading ? (
//                                 <tr>
//                                     <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
//                                         <RefreshCw className="animate-spin inline mr-2" size={16} />
//                                         Loading expenses with AI analysis...
//                                     </td>
//                                 </tr>
//                             ) : expenses.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
//                                         {statusFilter === 'all' ? 'No expenses found' :
//                                             statusFilter === 'synced' ? 'No synced expenses found' :
//                                                 statusFilter === 'unsynced' ? 'All expenses are synced!' :
//                                                     `No ${statusFilter} expenses found`}
//                                     </td>
//                                 </tr>
//                             ) : (
//                                 expenses.map((expense) => {
//                                     const paymentDisplay = getPaymentModeDisplay(expense);
//                                     const PaymentIcon = paymentDisplay.icon;
//                                     const isSynced = expense.is_synced;

//                                     return (
//                                         <tr key={expense.id} className={`hover:bg-gray-50 ${isSynced ? 'opacity-75' : ''}`}>
//                                             <td className="px-6 py-4">
//                                                 <div className="space-y-1">
//                                                     <div className="text-sm font-medium text-gray-900">
//                                                         {formatDate(expense.date)}
//                                                     </div>
//                                                     <div className="text-sm text-gray-600 max-w-xs">
//                                                         <div className="truncate">{expense.nature_of_expenses}</div>
//                                                         <div className="flex flex-wrap gap-1 mt-1">
//                                                             {expense.is_itemized && (
//                                                                 <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                                                                     <Calculator size={10} className="mr-1" />
//                                                                     Itemized
//                                                                 </span>
//                                                             )}
//                                                             {expense.has_bank_info && (
//                                                                 <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
//                                                                     {expense.bank_display_name}
//                                                                 </span>
//                                                             )}
//                                                             {isSynced && (
//                                                                 <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
//                                                                     <CheckCircle className="mr-1" size={10} />
//                                                                     Synced as {expense.sync_status}
//                                                                 </span>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4">
//                                                 <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg ${paymentDisplay.bgColor}`}>
//                                                     <PaymentIcon className={paymentDisplay.color} size={16} />
//                                                     <div className="text-sm">
//                                                         <div className="font-medium text-gray-900">
//                                                             {paymentDisplay.label}
//                                                         </div>
//                                                         <div className={`text-xs font-medium ${paymentDisplay.color}`}>
//                                                             Will sync as {paymentDisplay.syncAs}
//                                                         </div>
//                                                         {expense.employee_details && (
//                                                             <div className="text-xs text-green-700 mt-1">
//                                                                 <div className="font-medium">{expense.employee_details.name}</div>
//                                                                 <div className="text-green-600">{expense.employee_details.email}</div>
//                                                             </div>
//                                                         )}
//                                                         {paymentDisplay.requiresEmployee && !expense.employee_details && (
//                                                             <div className="text-xs text-red-600">
//                                                                 Missing employee info
//                                                             </div>
//                                                         )}
//                                                         {expense.bank_name && (
//                                                             <div className="text-xs text-gray-500 mt-1">
//                                                                 {expense.bank_name}
//                                                                 {expense.bank_last_4_digits && ` ****${expense.bank_last_4_digits}`}
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4">
//                                                 <div className="space-y-2">
//                                                     {/* Line Items Preview */}
//                                                     {expense.suggested_line_items && expense.suggested_line_items.length > 1 && (
//                                                         <div className="bg-purple-50 p-2 rounded border border-purple-200">
//                                                             <div className="flex items-center gap-1 mb-1">
//                                                                 <Calculator className="text-purple-600" size={12} />
//                                                                 <span className="text-xs font-medium text-purple-700">
//                                                                     {expense.suggested_line_items.length} AI Line Items
//                                                                 </span>
//                                                             </div>
//                                                             <div className="space-y-1">
//                                                                 {expense.suggested_line_items.slice(0, 2).map((item, idx) => (
//                                                                     <div key={idx} className="text-xs">
//                                                                         <div className="flex justify-between items-center">
//                                                                             <span className="text-gray-600 truncate max-w-24">
//                                                                                 {item.description}
//                                                                             </span>
//                                                                             <span className="font-medium text-purple-700">
//                                                                                 {formatCurrency(item.amount)}
//                                                                             </span>
//                                                                         </div>
//                                                                         {item.suggested_account_name && (
//                                                                             <div className="text-purple-600 truncate max-w-32">
//                                                                                 {item.suggested_account_name}
//                                                                                 {item.ai_confidence && (
//                                                                                     <span className="ml-1">
//                                                                                         ({Math.round(item.ai_confidence * 100)}%)
//                                                                                     </span>
//                                                                                 )}
//                                                                             </div>
//                                                                         )}
//                                                                     </div>
//                                                                 ))}
//                                                                 {expense.suggested_line_items.length > 2 && (
//                                                                     <div className="text-xs text-purple-600 font-medium">
//                                                                         +{expense.suggested_line_items.length - 2} more items
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     )}

//                                                     {/* Single Item AI Suggestions */}
//                                                     {(!expense.suggested_line_items || expense.suggested_line_items.length <= 1) && (
//                                                         <>
//                                                             {expense.ai_suggestions?.expense_account && (
//                                                                 <div className="flex items-center gap-2">
//                                                                     <Target className="text-purple-500" size={14} />
//                                                                     <div className="text-xs">
//                                                                         <span className="font-medium text-purple-700">Expense:</span>
//                                                                         <div className="text-gray-600 truncate max-w-32">
//                                                                             {expense.ai_suggestions.expense_account.account_name}
//                                                                         </div>
//                                                                         <div className="text-purple-600 font-medium">
//                                                                             {Math.round(expense.ai_suggestions.expense_account.confidence * 100)}% match
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             )}
//                                                         </>
//                                                     )}

//                                                     {expense.ai_suggestions?.payment_account && !paymentDisplay.requiresEmployee && (
//                                                         <div className="flex items-center gap-2">
//                                                             {expense.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
//                                                                 <CheckCircle className="text-green-500" size={14} />
//                                                             ) : (
//                                                                 <AlertTriangle className="text-orange-500" size={14} />
//                                                             )}
//                                                             <div className="text-xs">
//                                                                 <span className="font-medium text-blue-700">Payment:</span>
//                                                                 {expense.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
//                                                                     <>
//                                                                         <div className="text-gray-600 truncate max-w-32">
//                                                                             {expense.ai_suggestions.payment_account.account_name}
//                                                                         </div>
//                                                                         <div className="text-blue-600 font-medium">
//                                                                             {Math.round(expense.ai_suggestions.payment_account.confidence * 100)}% match
//                                                                         </div>
//                                                                     </>
//                                                                 ) : (
//                                                                     <div className="text-orange-600 text-xs">
//                                                                         Requires confirmation
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     )}

//                                                     {paymentDisplay.requiresEmployee && expense.employee_details && (
//                                                         <div className="flex items-center gap-2">
//                                                             <Building className="text-orange-500" size={14} />
//                                                             <div className="text-xs">
//                                                                 <span className="font-medium text-orange-700">Vendor:</span>
//                                                                 <div className="text-orange-600 font-medium">
//                                                                     Auto-create from employee
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     )}

//                                                     {!expense.ai_suggestions?.expense_account && !expense.suggested_line_items && !expense.ai_suggestions?.payment_account && (
//                                                         <div className="text-xs text-gray-500">
//                                                             No AI suggestions available
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4">
//                                                 <div className="space-y-1">
//                                                     <div className="text-sm font-medium text-gray-900">
//                                                         {formatCurrency(expense.amount)}
//                                                     </div>
//                                                     {isSynced ? (
//                                                         <div className="flex items-center gap-1 text-xs text-green-600">
//                                                             <CheckCircle size={12} />
//                                                             Synced
//                                                         </div>
//                                                     ) : (
//                                                         <div className="flex items-center gap-1 text-xs text-orange-600">
//                                                             <AlertCircle size={12} />
//                                                             Needs validation
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4">
//                                                 <div className="space-y-1">
//                                                     {expense.approval_info?.status === 'approved' && (
//                                                         <div className="flex items-center gap-1 text-xs text-green-600">
//                                                             <CheckCircle size={12} />
//                                                             Approved
//                                                         </div>
//                                                     )}
//                                                     {expense.approval_info?.status === 'pending_approval' && (
//                                                         <div className="flex items-center gap-1 text-xs text-orange-600">
//                                                             <AlertCircle size={12} />
//                                                             Pending Approval
//                                                             {expense.approval_info?.approved_by && (
//                                                                 <div className="text-xs text-gray-500 mt-1">
//                                                                     Approver: {expense.approval_info.approved_by}
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     )}
//                                                     {expense.approval_info?.status === 'rejected' && (
//                                                         <div className="flex items-center gap-1 text-xs text-red-600">
//                                                             <X size={12} />
//                                                             Rejected
//                                                             {expense.approval_info?.rejection_reason && (
//                                                                 <div className="text-xs text-red-500 mt-1" title={expense.approval_info.rejection_reason}>
//                                                                     {expense.approval_info.rejection_reason.length > 20
//                                                                         ? expense.approval_info.rejection_reason.substring(0, 20) + '...'
//                                                                         : expense.approval_info.rejection_reason
//                                                                     }
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                                 <div className="flex gap-2">
//                                                     {isSynced ? (
//                                                         <button
//                                                             disabled
//                                                             className="text-gray-400 cursor-not-allowed flex items-center gap-1"
//                                                             title="Already synced - cannot edit"
//                                                         >
//                                                             <Eye size={16} />
//                                                             Synced
//                                                         </button>
//                                                     ) : !expense.approval_info?.can_sync ? (
//                                                         <button
//                                                             disabled
//                                                             className="text-gray-400 cursor-not-allowed flex items-center gap-1"
//                                                             title={
//                                                                 expense.approval_info?.status === 'pending_approval'
//                                                                     ? `Pending approval from ${expense.approval_info?.approved_by || 'approver'}`
//                                                                     : expense.approval_info?.status === 'rejected'
//                                                                         ? `Rejected: ${expense.approval_info?.rejection_reason || 'No reason provided'}`
//                                                                         : 'Not approved for sync'
//                                                             }
//                                                         >
//                                                             <AlertCircle size={16} />
//                                                             {expense.approval_info?.status === 'pending_approval' ? 'Pending' :
//                                                                 expense.approval_info?.status === 'rejected' ? 'Rejected' : 'Not Approved'}
//                                                         </button>
//                                                     ) : (
//                                                         <button
//                                                             onClick={() => handleEditExpense(expense)}
//                                                             className="text-purple-600 hover:text-purple-900 flex items-center gap-1"
//                                                             title="Validate and sync with AI suggestions"
//                                                         >
//                                                             <Edit2 size={16} />
//                                                             {paymentDisplay.requiresEmployee && (
//                                                                 <User size={12} className="text-green-500" />
//                                                             )}
//                                                             {(expense.ai_suggestions?.expense_account || expense.suggested_line_items) && (
//                                                                 <Brain size={12} className="text-purple-500" />
//                                                             )}
//                                                             {expense.suggested_line_items && expense.suggested_line_items.length > 1 && (
//                                                                 <Calculator size={12} className="text-blue-500" />
//                                                             )}
//                                                             Validate & Sync
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     );
//                                 })
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {pagination.totalPages > 1 && (
//                     <div className="p-6 border-t flex justify-between items-center">
//                         <div className="text-sm text-gray-700">
//                             Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
//                             {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
//                         </div>
//                         <div className="flex gap-2">
//                             <button
//                                 onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
//                                 disabled={pagination.page === 1}
//                                 className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                             >
//                                 Previous
//                             </button>
//                             <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded">
//                                 {pagination.page} / {pagination.totalPages}
//                             </span>
//                             <button
//                                 onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
//                                 disabled={pagination.page === pagination.totalPages}
//                                 className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                             >
//                                 Next
//                             </button>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* ENHANCED EDIT MODAL with AI Validation and Line Items */}
//             {showEditModal && editingExpense && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[95vh] overflow-y-auto">
//                         {/* Header */}
//                         <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
//                             <h2 className="text-xl font-semibold flex items-center gap-2">
//                                 <Brain className="text-purple-600" size={20} />
//                                 Validate Expense - ID: {editingExpense.id}
//                                 {editForm.is_cash_payment && (
//                                     <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm flex items-center gap-1">
//                                         <User size={14} />
//                                         Cash → Bill
//                                     </span>
//                                 )}
//                                 {!editForm.is_cash_payment && (
//                                     <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm flex items-center gap-1">
//                                         <CreditCard size={14} />
//                                         Bank → Expense
//                                     </span>
//                                 )}
//                                 <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-sm flex items-center gap-1">
//                                     <Calculator size={14} />
//                                     {editForm.line_items.length} Line Items
//                                 </span>
//                             </h2>
//                             <button
//                                 onClick={() => setShowEditModal(false)}
//                                 className="text-gray-400 hover:text-gray-600 transition-colors"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>

//                         <div className="p-6 space-y-6">
//                             {/* Approval Status Banner */}
//                             {editingExpense && (
//                                 <div className={`p-4 rounded-lg border ${editingExpense.approval_info?.status === 'approved' ? 'bg-green-50 border-green-200' :
//                                     editingExpense.approval_info?.status === 'pending_approval' ? 'bg-orange-50 border-orange-200' :
//                                         editingExpense.approval_info?.status === 'rejected' ? 'bg-red-50 border-red-200' :
//                                             'bg-gray-50 border-gray-200'
//                                     }`}>
//                                     <h3 className={`text-lg font-medium mb-2 flex items-center gap-2 ${editingExpense.approval_info?.status === 'approved' ? 'text-green-900' :
//                                         editingExpense.approval_info?.status === 'pending_approval' ? 'text-orange-900' :
//                                             editingExpense.approval_info?.status === 'rejected' ? 'text-red-900' :
//                                                 'text-gray-900'
//                                         }`}>
//                                         {editingExpense.approval_info?.status === 'approved' && <CheckCircle className="text-green-600" size={18} />}
//                                         {editingExpense.approval_info?.status === 'pending_approval' && <AlertCircle className="text-orange-600" size={18} />}
//                                         {editingExpense.approval_info?.status === 'rejected' && <X className="text-red-600" size={18} />}
//                                         Approval Status: {editingExpense.approval_info?.status?.replace('_', ' ').toUpperCase() || 'UNKNOWN'}
//                                     </h3>

//                                     {editingExpense.approval_info?.status === 'approved' && (
//                                         <div className="text-sm text-green-700">
//                                             ✅ This expense has been approved and can be synced to Zoho Books.
//                                             {editingExpense.approval_info?.approved_by && (
//                                                 <div>Approved by: {editingExpense.approval_info.approved_by}</div>
//                                             )}
//                                         </div>
//                                     )}

//                                     {editingExpense.approval_info?.status === 'pending_approval' && (
//                                         <div className="text-sm text-orange-700">
//                                             ⏳ This expense is pending approval.
//                                             {editingExpense.approval_info?.approved_by && (
//                                                 <div>Please contact approver: {editingExpense.approval_info.approved_by}
//                                                     {editingExpense.approval_info?.approver_whatsapp && (
//                                                         <span> (WhatsApp: {editingExpense.approval_info.approver_whatsapp})</span>
//                                                     )}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     )}

//                                     {editingExpense.approval_info?.status === 'rejected' && (
//                                         <div className="text-sm text-red-700">
//                                             ❌ This expense has been rejected and cannot be synced to Zoho Books.
//                                             {editingExpense.approval_info?.rejection_reason && (
//                                                 <div className="mt-1">
//                                                     <strong>Reason:</strong> {editingExpense.approval_info.rejection_reason}
//                                                 </div>
//                                             )}
//                                             {editingExpense.approval_info?.approved_by && (
//                                                 <div>Rejected by: {editingExpense.approval_info.approved_by}</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* AI Suggestions Summary */}
//                             {editForm.ai_suggestions && (
//                                 <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
//                                     <h3 className="text-lg font-medium text-purple-900 mb-3 flex items-center gap-2">
//                                         <Brain className="text-purple-600" size={18} />
//                                         AI Suggestions Applied
//                                     </h3>

//                                     {/* Line Item Suggestions Summary */}
//                                     {editForm.line_items.some(item => item.ai_suggested) && (
//                                         <div className="mb-4">
//                                             <h4 className="text-md font-medium text-purple-800 mb-2">Expense Account Suggestions:</h4>
//                                             <div className="grid grid-cols-1 gap-2">
//                                                 {editForm.line_items.filter(item => item.ai_suggested).map((item, index) => (
//                                                     <div key={item.id} className="bg-white p-2 rounded border text-sm">
//                                                         <div className="flex items-center justify-between">
//                                                             <div className="flex items-center gap-2">
//                                                                 <Target className="text-purple-600" size={12} />
//                                                                 <span className="font-medium">{item.description}:</span>
//                                                                 <span className="text-gray-600">{item.suggested_account_name}</span>
//                                                             </div>
//                                                             <div className="flex items-center gap-2">
//                                                                 <span className="text-purple-600 text-xs">
//                                                                     {Math.round(item.ai_confidence * 100)}% confidence
//                                                                 </span>
//                                                                 <span className="font-medium text-green-600">
//                                                                     {formatCurrency(item.amount)}
//                                                                 </span>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* Payment Account Suggestion */}
//                                     {editForm.ai_suggestions.payment_account && !editForm.is_cash_payment && (
//                                         <div className="bg-white p-3 rounded border">
//                                             <div className="flex items-center gap-2 mb-2">
//                                                 {editForm.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
//                                                     <CheckCircle className="text-green-600" size={16} />
//                                                 ) : (
//                                                     <AlertTriangle className="text-orange-600" size={16} />
//                                                 )}
//                                                 <span className="font-medium text-blue-800">Payment Account</span>
//                                             </div>
//                                             {editForm.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
//                                                 <>
//                                                     <div className="text-sm text-gray-700">
//                                                         {editForm.ai_suggestions.payment_account.account_name}
//                                                     </div>
//                                                     <div className="text-xs text-blue-600 font-medium">
//                                                         {Math.round(editForm.ai_suggestions.payment_account.confidence * 100)}% match confirmed
//                                                     </div>
//                                                 </>
//                                             ) : (
//                                                 <div className="space-y-1">
//                                                     <div className="text-sm text-orange-700 font-medium">
//                                                         Requires Confirmation
//                                                     </div>
//                                                     <div className="text-xs text-orange-600">
//                                                         {editForm.ai_suggestions.payment_account.message}
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Employee Details for Cash Payments */}
//                             {editForm.is_cash_payment && editForm.employee_details && (
//                                 <div className="bg-green-50 p-4 rounded-lg border border-green-200">
//                                     <h3 className="text-lg font-medium text-green-900 mb-3 flex items-center gap-2">
//                                         <User className="text-green-600" size={18} />
//                                         Employee Vendor Details (Auto-created)
//                                     </h3>
//                                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                                         <div>
//                                             <span className="text-sm font-medium text-green-800">Name:</span>
//                                             <div className="text-gray-700">{editForm.employee_details.name}</div>
//                                         </div>
//                                         <div>
//                                             <span className="text-sm font-medium text-green-800">Email:</span>
//                                             <div className="text-gray-700">{editForm.employee_details.email}</div>
//                                         </div>
//                                         <div>
//                                             <span className="text-sm font-medium text-green-800">Phone:</span>
//                                             <div className="text-gray-700">{editForm.employee_details.phone}</div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Enhanced Basic Information */}
//                             <div className="bg-gray-50 p-4 rounded-lg">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Basic Information</h3>
//                                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Date *
//                                         </label>
//                                         <input
//                                             type="date"
//                                             value={editForm.date}
//                                             onChange={(e) => setEditForm(prev => ({ ...prev, date: e.target.value }))}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Description
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={editForm.nature_of_expenses}
//                                             onChange={(e) => setEditForm(prev => ({ ...prev, nature_of_expenses: e.target.value }))}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             placeholder="Expense description"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Total Amount (Calculated)
//                                         </label>
//                                         <div className="flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-md">
//                                             <Calculator className="text-green-600" size={16} />
//                                             <span className="text-lg font-bold text-green-700">
//                                                 {formatCurrency(calculateTotalAmount())}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* ENHANCED: Line Items Section with Add/Remove */}
//                             <div className="bg-white border border-gray-200 rounded-lg">
//                                 <div className="border-b border-gray-200 p-4 flex justify-between items-center">
//                                     <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
//                                         <Calculator className="text-blue-600" size={18} />
//                                         Line Items ({editForm.line_items.length} items)
//                                     </h3>
//                                     <div className="flex gap-2">
//                                         <button
//                                             onClick={handleManualAISuggestion}
//                                             disabled={loading}
//                                             className="px-3 py-1 bg-purple-600 text-white text-sm rounded-md hover:bg-purple-700 disabled:opacity-50 flex items-center gap-1"
//                                         >
//                                             <Brain size={14} />
//                                             {loading ? 'Getting AI Suggestions...' : 'AI Suggest Accounts'}
//                                         </button>
//                                         <button
//                                             onClick={addLineItem}
//                                             className="px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 flex items-center gap-1"
//                                         >
//                                             <Plus size={14} />
//                                             Add Item
//                                         </button>
//                                     </div>
//                                 </div>

//                                 <div className="p-4 space-y-4">
//                                     {editForm.line_items.map((item, index) => (
//                                         <div key={item.id} className="bg-gray-50 p-4 border rounded-lg">
//                                             <div className="flex justify-between items-start mb-3">
//                                                 <div className="flex items-center gap-2">
//                                                     <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
//                                                         Item {index + 1}
//                                                     </span>
//                                                     {getAISuggestionIndicator(item)}
//                                                     {item.manually_selected && (
//                                                         <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
//                                                             Manual Override
//                                                         </span>
//                                                     )}
//                                                 </div>
//                                                 {editForm.line_items.length > 1 && (
//                                                     <button
//                                                         onClick={() => removeLineItem(index)}
//                                                         className="text-red-600 hover:text-red-800 p-1"
//                                                         title="Remove this line item"
//                                                     >
//                                                         <Trash2 size={16} />
//                                                     </button>
//                                                 )}
//                                             </div>

//                                             <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
//                                                 <div className="md:col-span-5">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Description *
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.description}
//                                                         onChange={(e) => handleLineItemChange(index, 'description', e.target.value)}
//                                                         className="w-full px-2 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                         placeholder="Enter description"
//                                                         required
//                                                     />
//                                                     {item.original_text && (
//                                                         <div className="text-xs text-gray-500 mt-1 italic">
//                                                             Original: {item.original_text}
//                                                         </div>
//                                                     )}
//                                                 </div>

//                                                 <div className="md:col-span-2">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Amount *
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         step="0.01"
//                                                         min="0"
//                                                         value={item.amount}
//                                                         onChange={(e) => handleLineItemChange(index, 'amount', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                         placeholder="0.00"
//                                                         required
//                                                     />
//                                                 </div>

//                                                 <div className="md:col-span-5">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Expense Account *
//                                                         {item.ai_suggested && item.ai_confidence > 0 && (
//                                                             <span className="text-purple-600 text-xs ml-1">
//                                                                 (AI: {Math.round(item.ai_confidence * 100)}%)
//                                                             </span>
//                                                         )}
//                                                     </label>
//                                                     <select
//                                                         value={item.account_id || ''}
//                                                         onChange={(e) => {
//                                                             console.log(`Dropdown change for item ${index}:`, e.target.value);
//                                                             handleLineItemAccountChange(index, e.target.value);
//                                                         }}
//                                                         className="w-full px-2 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                         required
//                                                     >
//                                                         <option value="">Select account</option>
//                                                         {editForm.config_options?.expense_accounts?.map(account => (
//                                                             <option key={account.account_id} value={account.account_id}>
//                                                                 {account.account_name}
//                                                             </option>
//                                                         ))}
//                                                     </select>
//                                                     {item.suggested_account_name && (
//                                                         <div className="text-xs text-purple-600 mt-1 flex items-center gap-1">
//                                                             <Target size={10} />
//                                                             AI Suggested: {item.suggested_account_name}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* Configuration Section */}
//                             <div className="bg-white border border-gray-200 rounded-lg">
//                                 <div className="border-b border-gray-200 p-4">
//                                     <h3 className="text-lg font-medium text-gray-900">Sync Configuration</h3>
//                                 </div>

//                                 <div className="p-4">
//                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                         {!editForm.is_cash_payment && (
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                                                     Payment Account *
//                                                     {editForm.ai_suggestions?.payment_account?.validation_status === 'confirmed' && (
//                                                         <span className="text-green-600 text-xs ml-1">(AI Matched)</span>
//                                                     )}
//                                                     {editForm.ai_suggestions?.payment_account?.validation_status === 'requires_confirmation' && (
//                                                         <span className="text-orange-600 text-xs ml-1">(Please Confirm)</span>
//                                                     )}
//                                                 </label>
//                                                 <select
//                                                     value={expenseSyncConfig.paid_through_account_id}
//                                                     onChange={(e) => setExpenseSyncConfig(prev => ({
//                                                         ...prev,
//                                                         paid_through_account_id: e.target.value,
//                                                         payment_account_id: e.target.value
//                                                     }))}
//                                                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                     required
//                                                 >
//                                                     <option value="">Select payment account</option>
//                                                     {editForm.config_options?.payment_accounts?.map(account => (
//                                                         <option key={account.account_id} value={account.account_id}>
//                                                             {account.account_name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                                 {editForm.ai_suggestions?.payment_account?.validation_status === 'requires_confirmation' && (
//                                                     <p className="text-xs text-orange-600 mt-1">
//                                                         {editForm.ai_suggestions.payment_account.message}
//                                                     </p>
//                                                 )}
//                                             </div>
//                                         )}

//                                         <div>
//                                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                                 Reference Number
//                                             </label>
//                                             <input
//                                                 type="text"
//                                                 value={expenseSyncConfig.invoice_no}
//                                                 onChange={(e) => setExpenseSyncConfig(prev => ({ ...prev, invoice_no: e.target.value }))}
//                                                 placeholder={generateInvoiceNumber(editingExpense.id)}
//                                                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                             />
//                                         </div>

//                                         <div className="md:col-span-2">
//                                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                                 Notes
//                                             </label>
//                                             <textarea
//                                                 value={expenseSyncConfig.notes}
//                                                 onChange={(e) => setExpenseSyncConfig(prev => ({ ...prev, notes: e.target.value }))}
//                                                 rows={3}
//                                                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                                 placeholder="Additional notes for this expense"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Footer Actions with Enhanced Summary */}
//                         <div className="sticky bottom-0 bg-gray-50 px-6 py-4 border-t">
//                             {/* Summary Section */}
//                             <div className="mb-4 p-3 bg-white rounded border">
//                                 <h4 className="text-sm font-medium text-gray-900 mb-2">Sync Summary</h4>
//                                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
//                                     <div>
//                                         <span className="text-gray-600">Total Amount:</span>
//                                         <div className="font-bold text-green-600 text-lg">
//                                             {formatCurrency(calculateTotalAmount())}
//                                         </div>
//                                     </div>
//                                     <div>
//                                         <span className="text-gray-600">Line Items:</span>
//                                         <div className="font-medium text-blue-600">
//                                             {editForm.line_items.length} item{editForm.line_items.length !== 1 ? 's' : ''}
//                                         </div>
//                                     </div>
//                                     <div>
//                                         <span className="text-gray-600">AI Suggestions:</span>
//                                         <div className="font-medium text-purple-600">
//                                             {editForm.line_items.filter(item => item.ai_suggested).length} / {editForm.line_items.length}
//                                         </div>
//                                     </div>
//                                     <div>
//                                         <span className="text-gray-600">Sync Type:</span>
//                                         <div className={`font-medium ${editForm.is_cash_payment ? 'text-green-600' : 'text-blue-600'}`}>
//                                             {editForm.is_cash_payment ? 'Bill (Cash)' : 'Expense (Bank)'}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Validation Messages */}
//                                 <div className="mt-3 space-y-1">
//                                     {editForm.is_cash_payment && editForm.employee_details && (
//                                         <div className="text-sm text-green-600 font-medium flex items-center gap-1">
//                                             <User size={14} />
//                                             Employee vendor: {editForm.employee_details.name}
//                                         </div>
//                                     )}
//                                     {editForm.ai_suggestions?.payment_account?.validation_status === 'requires_confirmation' && (
//                                         <div className="text-sm text-orange-600 font-medium flex items-center gap-1">
//                                             <AlertTriangle size={14} />
//                                             Payment account needs confirmation
//                                         </div>
//                                     )}
//                                     {editForm.line_items.some(item => !item.account_id) && (
//                                         <div className="text-sm text-red-600 font-medium flex items-center gap-1">
//                                             <AlertCircle size={14} />
//                                             {editForm.line_items.filter(item => !item.account_id).length} line items missing expense accounts
//                                         </div>
//                                     )}
//                                     {editForm.line_items.some(item => parseFloat(item.amount) <= 0) && (
//                                         <div className="text-sm text-red-600 font-medium flex items-center gap-1">
//                                             <AlertCircle size={14} />
//                                             Some line items have zero or negative amounts
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="flex justify-between items-center">
//                                 <div className="text-sm text-gray-600">
//                                     {editForm.line_items.filter(item => item.ai_suggested).length > 0 && (
//                                         <span className="flex items-center gap-1">
//                                             <Brain size={14} className="text-purple-500" />
//                                             {editForm.line_items.filter(item => item.ai_suggested).length} AI suggestions applied
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div className="flex gap-3">
//                                     <button
//                                         onClick={() => setShowEditModal(false)}
//                                         className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
//                                         disabled={syncInProgress}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button
//                                         onClick={handleSyncExpense}
//                                         disabled={
//                                             syncInProgress ||
//                                             calculateTotalAmount() <= 0 ||
//                                             editForm.line_items.some(item => !item.account_id || !item.description.trim() || parseFloat(item.amount) <= 0) ||
//                                             (!editForm.is_cash_payment && !expenseSyncConfig.paid_through_account_id)
//                                         }
//                                         className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-colors"
//                                     >
//                                         <Upload size={16} />
//                                         {syncInProgress ? (
//                                             <>
//                                                 <RefreshCw size={16} className="animate-spin" />
//                                                 Syncing...
//                                             </>
//                                         ) : (
//                                             <>
//                                                 {editForm.is_cash_payment ? 'Sync as Bill' : 'Sync as Expense'}
//                                                 <span className="text-xs bg-blue-500 px-2 py-1 rounded">
//                                                     {editForm.line_items.length} items
//                                                 </span>
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Enhanced Progress Indicator */}
//             {syncInProgress && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                     <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
//                         <div className="text-center">
//                             <div className="flex justify-center mb-4">
//                                 <div className="relative">
//                                     <RefreshCw className="animate-spin text-blue-500" size={32} />
//                                     <Brain className="absolute inset-0 text-purple-500" size={16} style={{ margin: '8px' }} />
//                                 </div>
//                             </div>
//                             <h3 className="font-medium text-lg mb-2">AI-Powered Sync in Progress</h3>
//                             <div className="space-y-2 text-sm text-gray-600">
//                                 <p className="flex items-center justify-center gap-2">
//                                     <Calculator size={14} />
//                                     Processing {editForm.line_items.length} line items
//                                 </p>
//                                 <p>
//                                     {editForm.is_cash_payment ? (
//                                         <>
//                                             <User size={14} className="inline mr-1" />
//                                             Creating employee vendor and syncing as bill...
//                                         </>
//                                     ) : (
//                                         <>
//                                             <CreditCard size={14} className="inline mr-1" />
//                                             Validating payment account and syncing as expense...
//                                         </>
//                                     )}
//                                 </p>
//                                 {editForm.line_items.filter(item => item.ai_suggested).length > 0 && (
//                                     <p className="text-purple-600">
//                                         <Brain size={14} className="inline mr-1" />
//                                         Applying {editForm.line_items.filter(item => item.ai_suggested).length} AI suggestions
//                                     </p>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default DailySpendZohoIntegration;


import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
    RefreshCw,
    Cloud,
    CheckCircle,
    AlertCircle,
    Upload,
    Activity,
    Edit2,
    X,
    Calculator,
    Brain,
    Target,
    CreditCard,
    User,
    Building,
    AlertTriangle,
    Filter,
    Eye,
    Plus,
    Trash2,
    Wifi,
    WifiOff,
    XCircle
} from 'lucide-react';

// Error notification component
const ErrorNotification = ({ error, onClose }) => {
    if (!error) return null;

    return (
        <div className="fixed top-4 right-4 z-50 max-w-md bg-red-50 border border-red-200 rounded-lg shadow-lg p-4">
            <div className="flex items-start gap-3">
                <XCircle className="text-red-500 mt-0.5" size={20} />
                <div className="flex-1">
                    <h4 className="text-red-800 font-medium">{error.title}</h4>
                    <p className="text-red-600 text-sm mt-1">{error.message}</p>
                </div>
                <button
                    onClick={onClose}
                    className="text-red-400 hover:text-red-600"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
};

// Success notification component
const SuccessNotification = ({ message, onClose }) => {
    if (!message) return null;

    return (
        <div className="fixed top-4 right-4 z-50 max-w-md bg-green-50 border border-green-200 rounded-lg shadow-lg p-4">
            <div className="flex items-start gap-3">
                <CheckCircle className="text-green-500 mt-0.5" size={20} />
                <div className="flex-1">
                    <p className="text-green-800 font-medium">{message}</p>
                </div>
                <button
                    onClick={onClose}
                    className="text-green-400 hover:text-green-600"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
};

// Loading overlay component
const LoadingOverlay = ({ message = 'Loading...' }) => (
    <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
        <div className="flex items-center gap-2 text-gray-600">
            <RefreshCw className="animate-spin" size={20} />
            <span>{message}</span>
        </div>
    </div>
);

const DailySpendZohoIntegration = () => {
    // State management
    const [syncStatus, setSyncStatus] = useState(null);
    const [expenses, setExpenses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [syncInProgress, setSyncInProgress] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingExpense, setEditingExpense] = useState(null);
    const [statusFilter, setStatusFilter] = useState('all');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    // Pagination
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
    });

    // Edit form state
    const [editForm, setEditForm] = useState({
        nature_of_expenses: '',
        amount: 0,
        date: '',
        line_items: [],
        is_cash_payment: false,
        employee_details: null,
        ai_suggestions: null,
        config_options: null
    });

    // Sync configuration for the current expense
    const [expenseSyncConfig, setExpenseSyncConfig] = useState({
        expense_account_id: '',
        payment_account_id: '',
        paid_through_account_id: '',
        tax_id: '',
        gst_treatment: 'business_none',
        source_of_supply: 'TN',
        destination_of_supply: 'TN',
        is_inclusive_tax: false,
        invoice_no: '',
        notes: '',
        expense_type: 'service',
        is_reverse_charge: false
    });

    const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

    // Network status monitoring
    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    // Error handling utility
    const handleError = useCallback((error, context = 'An error occurred') => {
        console.error(`Error in ${context}:`, error);

        let errorMessage = 'An unexpected error occurred. Please try again.';
        let errorTitle = 'Error';

        if (error.name === 'TypeError' && error.message.includes('fetch')) {
            errorMessage = 'Unable to connect to the server. Please check your internet connection.';
            errorTitle = 'Connection Error';
        } else if (error.response) {
            // API error response
            errorTitle = `API Error (${error.response.status})`;
            errorMessage = error.response.data?.message || `Server returned ${error.response.status} error`;
        } else if (error.message) {
            errorMessage = error.message;
        }

        setError({
            title: errorTitle,
            message: errorMessage,
            context
        });
    }, []);

    // Success message utility
    const showSuccess = useCallback((message) => {
        setSuccessMessage(message);
        setTimeout(() => setSuccessMessage(''), 5000);
    }, []);

    // Get authentication headers with error handling
    const getAuthHeaders = useCallback(() => {
        const token = localStorage.getItem('authToken') ||
            localStorage.getItem('auth_token') ||
            localStorage.getItem('token');

        if (!token) {
            throw new Error('Authentication token not found. Please log in again.');
        }

        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
    }, []);

    // Enhanced fetch wrapper with error handling
    const apiRequest = useCallback(async (url, options = {}) => {
        if (!isOnline) {
            throw new Error('You are currently offline. Please check your internet connection.');
        }

        try {
            const headers = getAuthHeaders();
            const response = await fetch(url, {
                ...options,
                headers: { ...headers, ...options.headers }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                const error = new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
                error.response = { status: response.status, data: errorData };
                throw error;
            }

            return await response.json();
        } catch (error) {
            if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
                throw new Error('Network error: Unable to reach the server. Please check your connection.');
            }
            throw error;
        }
    }, [getAuthHeaders, isOnline]);

    // Fetch sync status with error handling
    const fetchSyncStatus = useCallback(async () => {
        try {
            const data = await apiRequest(`${API_BASE_URL}/zoho/sync-status`);
            if (data.success) {
                setSyncStatus(data.data);
            } else {
                throw new Error(data.message || 'Failed to fetch sync status');
            }
        } catch (error) {
            handleError(error, 'fetching sync status');
        }
    }, [apiRequest, handleError]);

    // Fetch expenses with error handling
    const fetchExpenses = useCallback(async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams({
                limit: pagination.limit.toString(),
                page: pagination.page.toString()
            });

            if (statusFilter !== 'all') {
                params.append('status_filter', statusFilter);
            }

            const data = await apiRequest(`${API_BASE_URL}/zoho/expenses?${params}`);
            if (data.success) {
                setExpenses(data.data || []);
                if (data.pagination) {
                    setPagination(prev => ({
                        ...prev,
                        total: data.pagination.total,
                        totalPages: data.pagination.totalPages
                    }));
                }
            } else {
                throw new Error(data.message || 'Failed to fetch expenses');
            }
        } catch (error) {
            handleError(error, 'fetching expenses');
            setExpenses([]); // Clear expenses on error
        } finally {
            setLoading(false);
        }
    }, [pagination.limit, pagination.page, statusFilter, apiRequest, handleError]);

    // Initial data loading
    useEffect(() => {
        fetchSyncStatus();
        fetchExpenses();
    }, [fetchSyncStatus, fetchExpenses]);

    // Refetch when pagination or filter changes
    useEffect(() => {
        fetchExpenses();
    }, [pagination.page, statusFilter, fetchExpenses]);

    // Date formatting utility
    const formatDateForInput = useCallback((dateString) => {
        if (!dateString) return '';
        if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';

            return date.toISOString().split('T')[0];
        } catch {
            return '';
        }
    }, []);

    // Invoice number generator
    const generateInvoiceNumber = useCallback((expenseId) => {
        const paddedId = String(expenseId).padStart(4, '0');
        return `EXP-${paddedId}`;
    }, []);

    // Replace your existing permission check functions with these simplified versions
    const canSync = useCallback((expense) => {
        // Check multiple possible field names and values
        const status = expense.approvalinfo?.status || expense.approver_status || expense.approval_status;
        const canSyncFlag = expense.approvalinfo?.can_sync;
        
        console.log('🔍 Checking sync permission for expense', expense.id, {
            status,
            canSyncFlag,
            approvalinfo: expense.approvalinfo
        });
        
        // Allow sync if explicitly marked as can_sync=true OR status is approved OR no status (null/undefined means approved)
        return canSyncFlag === true || status === 'approved' || !status;
    }, []);

    const canEdit = useCallback((expense) => {
        return canSync(expense); // Same logic for now
    }, [canSync]);

    const canValidate = useCallback((expense) => {
        return canSync(expense); // Same logic for now
    }, [canSync]);


    // Get approval status display
    const getApprovalStatusDisplay = useCallback((expense) => {
        const status = expense.approval_info?.status;

        if (!status || status === 'approved') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    Approved
                    {expense.approval_info?.approved_by && (
                        <span className="ml-1">by {expense.approval_info.approved_by}</span>
                    )}
                </span>
            );
        }

        if (status === 'pending_approval') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    Pending Approval
                </span>
            );
        }

        if (status === 'rejected') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                    <XCircle className="w-3 h-3 mr-1" />
                    Rejected
                    {expense.approval_info?.rejection_reason && (
                        <div className="text-xs mt-1" title={expense.approval_info.rejection_reason}>
                            Reason: {expense.approval_info.rejection_reason.substring(0, 30)}...
                        </div>
                    )}
                </span>
            );
        }

        return null;
    }, []);

    // Enhanced handleEditExpense function
    const handleEditExpense = useCallback(async (expense) => {
        setEditingExpense(expense);

        try {
            const data = await apiRequest(`${API_BASE_URL}/zoho/expense-details/${expense.id}`);

            if (!data.success) {
                throw new Error(data.message || 'Failed to fetch expense details');
            }

            const expenseDetails = data.data;
            let lineItems = [];

            // Process line items
            if (expenseDetails.suggested_line_items?.length > 0) {
                lineItems = expenseDetails.suggested_line_items.map((item, index) => ({
                    id: item.id || `line_${index}`,
                    description: item.description || '',
                    amount: parseFloat(item.amount) || 0,
                    expense_type: item.expense_type || 'service',
                    account_id: item.account_id || '',
                    suggested_account_name: item.suggested_account_name || '',
                    ai_confidence: item.ai_confidence || 0,
                    ai_suggested: true,
                    original_text: item.original_text || ''
                }));
            } else if (expenseDetails.line_items?.length > 0) {
                lineItems = expenseDetails.line_items.map((item, index) => ({
                    id: item.id || `line_${index}`,
                    description: item.description || '',
                    amount: parseFloat(item.amount) || 0,
                    expense_type: item.expense_type || 'service',
                    account_id: item.account_id || '',
                    suggested_account_name: '',
                    ai_confidence: 0,
                    ai_suggested: false
                }));
            } else {
                lineItems = [{
                    id: 'line_0',
                    description: expenseDetails.nature_of_expenses || 'General Expense',
                    amount: parseFloat(expenseDetails.amount) || 0,
                    expense_type: 'service',
                    account_id: expenseDetails.ai_suggestions?.expense_account?.account_id || '',
                    suggested_account_name: expenseDetails.ai_suggestions?.expense_account?.account_name || '',
                    ai_confidence: expenseDetails.ai_suggestions?.expense_account?.confidence || 0,
                    ai_suggested: !!expenseDetails.ai_suggestions?.expense_account
                }];
            }

            setEditForm({
                nature_of_expenses: expenseDetails.nature_of_expenses || '',
                amount: expenseDetails.amount || 0,
                date: formatDateForInput(expenseDetails.date),
                line_items: lineItems,
                is_cash_payment: expenseDetails.is_cash_payment || false,
                employee_details: expenseDetails.employee_details || null,
                ai_suggestions: expenseDetails.ai_suggestions || null,
                config_options: expenseDetails.config_options || null
            });

            // Set sync configuration
            const defaultConfig = {
                invoice_no: generateInvoiceNumber(expenseDetails.id),
                expense_account_id: lineItems.length > 0 ? lineItems[0].account_id : '',
                payment_account_id: expenseDetails.ai_suggestions?.payment_account?.account_id || '',
                paid_through_account_id: expenseDetails.ai_suggestions?.payment_account?.account_id || '',
                expense_type: 'service',
                gst_treatment: 'business_none',
                source_of_supply: 'TN',
                destination_of_supply: 'TN',
                notes: expenseDetails.is_cash_payment && expenseDetails.employee_details ?
                    `Cash payment by employee: ${expenseDetails.employee_details.name}` : ''
            };

            setExpenseSyncConfig(defaultConfig);
            setShowEditModal(true);

        } catch (error) {
            handleError(error, 'loading expense details');
        }
    }, [apiRequest, formatDateForInput, generateInvoiceNumber, handleError]);

    // Line item management functions
    const handleLineItemChange = useCallback((index, field, value) => {
        setEditForm(prev => ({
            ...prev,
            line_items: prev.line_items.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    }, []);

    const addLineItem = useCallback(() => {
        const newItem = {
            id: `line_${Date.now()}`,
            description: '',
            amount: 0,
            expense_type: 'service',
            account_id: '',
            suggested_account_name: '',
            ai_confidence: 0,
            ai_suggested: false
        };

        setEditForm(prev => ({
            ...prev,
            line_items: [...prev.line_items, newItem]
        }));
    }, []);

    const removeLineItem = useCallback((index) => {
        if (editForm.line_items.length > 1) {
            setEditForm(prev => ({
                ...prev,
                line_items: prev.line_items.filter((_, i) => i !== index)
            }));
        }
    }, [editForm.line_items.length]);

    const handleLineItemAccountChange = useCallback((index, accountId) => {
        setEditForm(prev => {
            const updatedLineItems = prev.line_items.map((item, i) =>
                i === index ? {
                    ...item,
                    account_id: accountId,
                    manually_selected: item.ai_suggested && accountId !== item.account_id
                } : item
            );

            return {
                ...prev,
                line_items: updatedLineItems
            };
        });
    }, []);

    // Calculate total amount
    const calculateTotalAmount = useCallback(() => {
        return editForm.line_items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
    }, [editForm.line_items]);

    // Enhanced sync expense function
    const handleSyncExpense = useCallback(async () => {
        try {
            setSyncInProgress(true);

            // Validation
            const invalidItems = editForm.line_items.filter(item => !item.account_id || !item.description.trim());
            if (invalidItems.length > 0) {
                throw new Error(`Please complete all line items. ${invalidItems.length} items are missing account selection or description.`);
            }

            const zeroAmountItems = editForm.line_items.filter(item => parseFloat(item.amount) <= 0);
            if (zeroAmountItems.length > 0) {
                throw new Error('All line items must have amounts greater than zero.');
            }

            if (!editForm.is_cash_payment && !expenseSyncConfig.paid_through_account_id) {
                throw new Error('Please select a payment account for bank payments');
            }

            // Prepare sync configuration
            const syncConfig = {
                ...expenseSyncConfig,
                line_items: editForm.line_items.map(item => ({
                    description: item.description.trim(),
                    amount: parseFloat(item.amount),
                    account_id: item.account_id,
                    expense_type: item.expense_type || 'service',
                    ai_suggested: item.ai_suggested || false,
                    ai_confidence: item.ai_confidence || 0,
                    manually_selected: item.manually_selected || false
                })),
                date: editForm.date,
                custom_amount: calculateTotalAmount(),
                total_line_items: editForm.line_items.length,
                has_ai_suggestions: editForm.line_items.some(item => item.ai_suggested),
                nature_of_expenses: editForm.nature_of_expenses
            };

            const data = await apiRequest(`${API_BASE_URL}/zoho/sync-expense/${editingExpense.id}`, {
                method: 'POST',
                body: JSON.stringify(syncConfig)
            });

            if (data.success) {
                showSuccess(data.message || 'Expense synced successfully!');
                setShowEditModal(false);
                setEditingExpense(null);
                fetchSyncStatus();
                fetchExpenses();
            } else {
                // Handle approval status errors
                if (data.approval_status) {
                    let errorMessage = data.message;

                    if (data.approval_status === 'pending_approval' && data.approver_details) {
                        errorMessage += `\n\nApprover: ${data.approver_details.name || 'Unknown'}`;
                        if (data.approver_details.whatsapp) {
                            errorMessage += `\nWhatsApp: ${data.approver_details.whatsapp}`;
                        }
                        if (data.approver_details.email) {
                            errorMessage += `\nEmail: ${data.approver_details.email}`;
                        }
                    }

                    if (data.approval_status === 'rejected' && data.rejection_reason) {
                        errorMessage += `\n\nRejection Reason: ${data.rejection_reason}`;
                    }

                    throw new Error(errorMessage);
                } else {
                    throw new Error(data.message || 'Failed to sync expense');
                }
            }
        } catch (error) {
            handleError(error, 'syncing expense');
        } finally {
            setSyncInProgress(false);
        }
    }, [
        editForm,
        expenseSyncConfig,
        editingExpense,
        calculateTotalAmount,
        apiRequest,
        showSuccess,
        handleError,
        fetchSyncStatus,
        fetchExpenses
    ]);

    // Format currency
    const formatCurrency = useCallback((amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount || 0);
    }, []);

    // Format date
    const formatDate = useCallback((dateString) => {
        if (!dateString) return 'Never';
        return new Date(dateString).toLocaleDateString('en-IN');
    }, []);

    // Get payment mode display
    const getPaymentModeDisplay = useCallback((expense) => {
        const mode = expense.mode_of_payment ? expense.mode_of_payment.toLowerCase() : 'bank';

        if (mode === 'cash') {
            return {
                icon: User,
                color: 'text-green-600',
                label: 'Cash',
                bgColor: 'bg-green-50',
                syncAs: 'Bill',
                requiresEmployee: true
            };
        } else {
            return {
                icon: CreditCard,
                color: 'text-blue-600',
                label: 'Bank/Card',
                bgColor: 'bg-blue-50',
                syncAs: 'Expense',
                requiresEmployee: false
            };
        }
    }, []);

    // Handle status filter
    const handleStatusFilterClick = useCallback((filter) => {
        setStatusFilter(filter);
        setPagination(prev => ({ ...prev, page: 1 }));
    }, []);

    // Get AI suggestion indicator
    const getAISuggestionIndicator = useCallback((item) => {
        if (!item.ai_suggested) return null;

        const confidenceLevel = item.ai_confidence * 100;
        let color = 'text-purple-600';
        let bgColor = 'bg-purple-100';

        if (confidenceLevel >= 80) {
            color = 'text-green-600';
            bgColor = 'bg-green-100';
        } else if (confidenceLevel >= 60) {
            color = 'text-yellow-600';
            bgColor = 'bg-yellow-100';
        }

        return (
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${bgColor} ${color}`}>
                <Brain size={10} className="mr-1" />
                AI: {Math.round(confidenceLevel)}%
            </span>
        );
    }, []);

    // Handle manual AI suggestions
    const handleManualAISuggestion = useCallback(async () => {
        if (!editingExpense) return;

        try {
            setLoading(true);
            const data = await apiRequest(`${API_BASE_URL}/zoho/expense-details/${editingExpense.id}?force_ai_suggestions=true`);

            if (data.success) {
                const expenseDetails = data.data;

                if (expenseDetails.suggested_line_items) {
                    const updatedLineItems = expenseDetails.suggested_line_items.map(item => ({
                        ...item,
                        account_id: item.account_id || '',
                        ai_suggested: item.ai_suggested || false,
                        ai_confidence: item.ai_confidence || 0,
                        suggested_account_name: item.suggested_account_name || ''
                    }));

                    setEditForm(prev => ({
                        ...prev,
                        line_items: updatedLineItems,
                        ai_suggestions: expenseDetails.ai_suggestions
                    }));

                    if (updatedLineItems.length > 0 && updatedLineItems[0].account_id) {
                        setExpenseSyncConfig(prev => ({
                            ...prev,
                            expense_account_id: updatedLineItems[0].account_id
                        }));
                    }

                    const successCount = updatedLineItems.filter(item => item.ai_suggested && item.account_id).length;
                    showSuccess(`AI suggestions applied! ${successCount} out of ${updatedLineItems.length} items got account suggestions.`);
                } else {
                    throw new Error('No line items received from AI suggestions.');
                }
            } else {
                throw new Error(data.message || 'Failed to get AI suggestions');
            }
        } catch (error) {
            handleError(error, 'getting AI suggestions');
        } finally {
            setLoading(false);
        }
    }, [editingExpense, apiRequest, showSuccess, handleError]);

    // Memoized calculations
    const syncStatusCards = useMemo(() => {
        if (!syncStatus) return null;

        return [
            {
                key: 'all',
                icon: Activity,
                title: 'Total Expenses',
                value: syncStatus.total_expenses,
                color: 'blue'
            },
            {
                key: 'synced',
                icon: CheckCircle,
                title: 'Synced',
                value: syncStatus.synced_expenses,
                subtitle: `${syncStatus.cash_bills_synced || 0} bills + ${syncStatus.bank_expenses_synced || 0} expenses`,
                color: 'green'
            },
            {
                key: 'unsynced',
                icon: AlertCircle,
                title: 'Pending',
                value: syncStatus.unsynced_expenses,
                subtitle: 'Requires validation',
                color: 'orange'
            },
            {
                key: 'cash',
                icon: User,
                title: 'Cash Payments',
                value: syncStatus.cash_payments || 0,
                subtitle: 'Will sync as bills',
                color: 'green'
            },
            {
                key: 'bank',
                icon: CreditCard,
                title: 'Bank Payments',
                value: syncStatus.bank_payments || 0,
                subtitle: 'Will sync as expenses',
                color: 'blue'
            }
        ];
    }, [syncStatus]);

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-4 sm:space-y-6">
                {/* Error and Success Notifications */}
                <ErrorNotification error={error} onClose={() => setError(null)} />
                <SuccessNotification message={successMessage} onClose={() => setSuccessMessage('')} />

                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                    <div>
                        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-2">
                            <Cloud className="text-blue-600" size={32} />
                            AI-Powered Zoho Integration
                        </h1>
                        <p className="text-gray-600 mt-1 text-sm sm:text-base">
                            Individual expense validation with AI suggestions - Line-by-line itemization
                        </p>
                    </div>

                    <div className="flex items-center gap-3">
                        {/* Network status indicator */}
                        <div className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm ${isOnline
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                            }`}>
                            {isOnline ? <Wifi size={16} /> : <WifiOff size={16} />}
                            {isOnline ? 'Online' : 'Offline'}
                        </div>

                        <button
                            onClick={() => {
                                fetchSyncStatus();
                                fetchExpenses();
                            }}
                            disabled={loading || !isOnline}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 text-sm sm:text-base"
                        >
                            <RefreshCw className={loading ? 'animate-spin' : ''} size={16} />
                            Refresh
                        </button>
                    </div>
                </div>

                {/* Enhanced Sync Status Dashboard */}
                {syncStatusCards && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
                        {syncStatusCards.map((card) => {
                            const IconComponent = card.icon;
                            const isActive = statusFilter === card.key;
                            const colorClasses = {
                                blue: isActive ? 'text-blue-600' : 'text-blue-500',
                                green: isActive ? 'text-green-600' : 'text-green-500',
                                orange: isActive ? 'text-orange-600' : 'text-orange-500'
                            };

                            return (
                                <div
                                    key={card.key}
                                    className="bg-white p-3 sm:p-4 rounded-lg shadow border cursor-pointer hover:shadow-md transition-shadow"
                                    onClick={() => handleStatusFilterClick(card.key)}
                                >
                                    <div className="flex items-center gap-2 mb-2">
                                        <IconComponent className={colorClasses[card.color]} size={18} />
                                        <h3 className="font-medium text-gray-900 text-sm sm:text-base">{card.title}</h3>
                                    </div>
                                    <div className="text-xl sm:text-2xl font-bold text-gray-900">{card.value}</div>
                                    {card.subtitle && (
                                        <div className="text-xs text-gray-500 mt-1">{card.subtitle}</div>
                                    )}
                                    {isActive && (
                                        <div className={`text-xs font-medium mt-1 ${colorClasses[card.color]}`}>
                                            Currently viewing
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Active Filter Display */}
                {statusFilter !== 'all' && (
                    <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                        <div className="flex items-center gap-2">
                            <Filter className="text-blue-600" size={16} />
                            <span className="text-blue-800 font-medium text-sm">
                                Currently viewing: {statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)} expenses
                            </span>
                        </div>
                        <button
                            onClick={() => handleStatusFilterClick('all')}
                            className="text-blue-600 hover:text-blue-800 text-sm font-medium self-start sm:self-center"
                        >
                            Clear filter
                        </button>
                    </div>
                )}

                {/* Expenses Table with AI Suggestions */}
                <div className="bg-white rounded-lg shadow border relative">
                    {loading && <LoadingOverlay message="Loading expenses with AI analysis..." />}

                    <div className="p-4 sm:p-6 border-b">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                            <div>
                                <h3 className="text-lg font-semibold flex items-center gap-2">
                                    <Brain className="text-purple-500" size={20} />
                                    Expenses with AI-Powered Line Item Validation
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Each expense requires individual validation with AI suggestions for each line item
                                </p>
                            </div>
                            <div className="text-sm text-gray-500">
                                Showing {expenses.length} of {pagination.total} expenses
                            </div>
                        </div>
                    </div>

                    {/* Mobile-first responsive table */}
                    <div className="overflow-x-auto">
                        <div className="min-w-full">
                            {/* Desktop table */}
                            <div className="hidden lg:block">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Date & Description
                                            </th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Payment Mode & Employee
                                            </th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                AI Suggestions & Line Items
                                            </th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Amount & Status
                                            </th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Approval Status
                                            </th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {expenses.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                                                    {isOnline ? (
                                                        statusFilter === 'all' ? 'No expenses found' :
                                                            statusFilter === 'synced' ? 'No synced expenses found' :
                                                                statusFilter === 'unsynced' ? 'All expenses are synced!' :
                                                                    `No ${statusFilter} expenses found`
                                                    ) : (
                                                        <div className="flex flex-col items-center gap-2">
                                                            <WifiOff className="text-gray-400" size={24} />
                                                            <span>You are offline. Expenses cannot be loaded.</span>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ) : (
                                            expenses.map((expense) => {
                                                const paymentDisplay = getPaymentModeDisplay(expense);
                                                const PaymentIcon = paymentDisplay.icon;
                                                const isSynced = expense.is_synced;

                                                return (
                                                    <tr key={expense.id} className={`hover:bg-gray-50 ${isSynced ? 'opacity-75' : ''}`}>
                                                        <td className="px-6 py-4">
                                                            <div className="space-y-1">
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {formatDate(expense.date)}
                                                                </div>
                                                                <div className="text-sm text-gray-600 max-w-xs">
                                                                    <div className="truncate">{expense.nature_of_expenses}</div>
                                                                    <div className="flex flex-wrap gap-1 mt-1">
                                                                        {expense.is_itemized && (
                                                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                                                <Calculator size={10} className="mr-1" />
                                                                                Itemized
                                                                            </span>
                                                                        )}
                                                                        {expense.has_bank_info && (
                                                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                                                {expense.bank_display_name}
                                                                            </span>
                                                                        )}
                                                                        {isSynced && (
                                                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                                                                <CheckCircle className="mr-1" size={10} />
                                                                                Synced as {expense.sync_status}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg ${paymentDisplay.bgColor}`}>
                                                                <PaymentIcon className={paymentDisplay.color} size={16} />
                                                                <div className="text-sm">
                                                                    <div className="font-medium text-gray-900">
                                                                        {paymentDisplay.label}
                                                                    </div>
                                                                    <div className={`text-xs font-medium ${paymentDisplay.color}`}>
                                                                        Will sync as {paymentDisplay.syncAs}
                                                                    </div>
                                                                    {expense.employee_details && (
                                                                        <div className="text-xs text-green-700 mt-1">
                                                                            <div className="font-medium">{expense.employee_details.name}</div>
                                                                            <div className="text-green-600">{expense.employee_details.email}</div>
                                                                        </div>
                                                                    )}
                                                                    {paymentDisplay.requiresEmployee && !expense.employee_details && (
                                                                        <div className="text-xs text-red-600">
                                                                            Missing employee info
                                                                        </div>
                                                                    )}
                                                                    {expense.bank_name && (
                                                                        <div className="text-xs text-gray-500 mt-1">
                                                                            {expense.bank_name}
                                                                            {expense.bank_last_4_digits && ` ****${expense.bank_last_4_digits}`}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className="space-y-2">
                                                                {/* Line Items Preview */}
                                                                {expense.suggested_line_items && expense.suggested_line_items.length > 1 && (
                                                                    <div className="bg-purple-50 p-2 rounded border border-purple-200">
                                                                        <div className="flex items-center gap-1 mb-1">
                                                                            <Calculator className="text-purple-600" size={12} />
                                                                            <span className="text-xs font-medium text-purple-700">
                                                                                {expense.suggested_line_items.length} AI Line Items
                                                                            </span>
                                                                        </div>
                                                                        <div className="space-y-1">
                                                                            {expense.suggested_line_items.slice(0, 2).map((item, idx) => (
                                                                                <div key={idx} className="text-xs">
                                                                                    <div className="flex justify-between items-center">
                                                                                        <span className="text-gray-600 truncate max-w-24">
                                                                                            {item.description}
                                                                                        </span>
                                                                                        <span className="font-medium text-purple-700">
                                                                                            {formatCurrency(item.amount)}
                                                                                        </span>
                                                                                    </div>
                                                                                    {item.suggested_account_name && (
                                                                                        <div className="text-purple-600 truncate max-w-32">
                                                                                            {item.suggested_account_name}
                                                                                            {item.ai_confidence && (
                                                                                                <span className="ml-1">
                                                                                                    ({Math.round(item.ai_confidence * 100)}%)
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                            {expense.suggested_line_items.length > 2 && (
                                                                                <div className="text-xs text-purple-600 font-medium">
                                                                                    +{expense.suggested_line_items.length - 2} more items
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Single Item AI Suggestions */}
                                                                {(!expense.suggested_line_items || expense.suggested_line_items.length <= 1) && (
                                                                    <>
                                                                        {expense.ai_suggestions?.expense_account && (
                                                                            <div className="flex items-center gap-2">
                                                                                <Target className="text-purple-500" size={14} />
                                                                                <div className="text-xs">
                                                                                    <span className="font-medium text-purple-700">Expense:</span>
                                                                                    <div className="text-gray-600 truncate max-w-32">
                                                                                        {expense.ai_suggestions.expense_account.account_name}
                                                                                    </div>
                                                                                    <div className="text-purple-600 font-medium">
                                                                                        {Math.round(expense.ai_suggestions.expense_account.confidence * 100)}% match
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}

                                                                {expense.ai_suggestions?.payment_account && !paymentDisplay.requiresEmployee && (
                                                                    <div className="flex items-center gap-2">
                                                                        {expense.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
                                                                            <CheckCircle className="text-green-500" size={14} />
                                                                        ) : (
                                                                            <AlertTriangle className="text-orange-500" size={14} />
                                                                        )}
                                                                        <div className="text-xs">
                                                                            <span className="font-medium text-blue-700">Payment:</span>
                                                                            {expense.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
                                                                                <>
                                                                                    <div className="text-gray-600 truncate max-w-32">
                                                                                        {expense.ai_suggestions.payment_account.account_name}
                                                                                    </div>
                                                                                    <div className="text-blue-600 font-medium">
                                                                                        {Math.round(expense.ai_suggestions.payment_account.confidence * 100)}% match
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div className="text-orange-600 text-xs">
                                                                                    Requires confirmation
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {paymentDisplay.requiresEmployee && expense.employee_details && (
                                                                    <div className="flex items-center gap-2">
                                                                        <Building className="text-orange-500" size={14} />
                                                                        <div className="text-xs">
                                                                            <span className="font-medium text-orange-700">Vendor:</span>
                                                                            <div className="text-orange-600 font-medium">
                                                                                Auto-create from employee
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {!expense.ai_suggestions?.expense_account && !expense.suggested_line_items && !expense.ai_suggestions?.payment_account && (
                                                                    <div className="text-xs text-gray-500">
                                                                        No AI suggestions available
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className="space-y-1">
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {formatCurrency(expense.amount)}
                                                                </div>
                                                                {isSynced ? (
                                                                    <div className="flex items-center gap-1 text-xs text-green-600">
                                                                        <CheckCircle size={12} />
                                                                        Synced
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex items-center gap-1 text-xs text-orange-600">
                                                                        <AlertCircle size={12} />
                                                                        Needs validation
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            {getApprovalStatusDisplay(expense)}
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                            <div className="flex gap-2">
                                                                {isSynced ? (
                                                                    <button
                                                                        disabled
                                                                        className="text-gray-400 cursor-not-allowed flex items-center gap-1"
                                                                        title="Already synced - cannot edit"
                                                                    >
                                                                        <Eye size={16} />
                                                                        <span className="hidden sm:inline">Synced</span>
                                                                    </button>
                                                                ) : (
                                                                    // ✅ FIXED: Check approval status correctly
                                                                    (expense.approvalinfo?.status !== 'approved' && expense.approvalinfo?.status !== null && expense.approvalinfo?.status !== undefined) ? (
                                                                        <button
                                                                            disabled
                                                                            className="text-gray-400 cursor-not-allowed flex items-center gap-1"
                                                                            title={`Cannot sync: ${expense.approvalinfo?.status === 'pending_approval'
                                                                                ? `Pending approval from ${expense.approvalinfo?.approved_by || 'approver'}`
                                                                                : expense.approvalinfo?.status === 'rejected'
                                                                                    ? `Rejected: ${expense.approvalinfo?.rejection_reason || 'No reason provided'}`
                                                                                    : 'Not approved for sync'
                                                                                }`}
                                                                        >
                                                                            <AlertCircle size={16} />
                                                                            <span className="hidden sm:inline">
                                                                                {expense.approvalinfo?.status === 'pending_approval'
                                                                                    ? 'Pending'
                                                                                    : expense.approvalinfo?.status === 'rejected'
                                                                                        ? 'Rejected'
                                                                                        : 'Not Approved'}
                                                                            </span>
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            onClick={() => handleEditExpense(expense)}
                                                                            disabled={!isOnline}
                                                                            className="text-purple-600 hover:text-purple-900 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                                                                            title="Validate and sync with AI suggestions"
                                                                        >
                                                                            <Edit2 size={16} />
                                                                            {expense.payment_mode_info?.requires_employee_vendor && <User size={12} className="text-green-500" />}
                                                                            {expense.aisuggestions?.expenseaccount && <Brain size={12} className="text-purple-500" />}
                                                                            <span className="hidden sm:inline">Validate & Sync</span>
                                                                            <span className="sm:hidden">Edit</span>
                                                                        </button>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile card layout */}
                            <div className="lg:hidden divide-y divide-gray-200">
                                {expenses.length === 0 ? (
                                    <div className="p-6 text-center text-gray-500">
                                        {isOnline ? (
                                            statusFilter === 'all' ? 'No expenses found' :
                                                statusFilter === 'synced' ? 'No synced expenses found' :
                                                    statusFilter === 'unsynced' ? 'All expenses are synced!' :
                                                        `No ${statusFilter} expenses found`
                                        ) : (
                                            <div className="flex flex-col items-center gap-2">
                                                <WifiOff className="text-gray-400" size={24} />
                                                <span>You are offline. Expenses cannot be loaded.</span>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    expenses.map((expense) => {
                                        const paymentDisplay = getPaymentModeDisplay(expense);
                                        const PaymentIcon = paymentDisplay.icon;
                                        const isSynced = expense.is_synced;

                                        return (
                                            <div key={expense.id} className={`p-4 ${isSynced ? 'opacity-75' : ''}`}>
                                                {/* Header with date and amount */}
                                                <div className="flex justify-between items-start mb-3">
                                                    <div>
                                                        <div className="text-sm font-medium text-gray-900">
                                                            {formatDate(expense.date)}
                                                        </div>
                                                        <div className="text-xs text-gray-500 mt-1">ID: {expense.id}</div>
                                                    </div>
                                                    <div className="text-right">
                                                        <div className="text-lg font-bold text-gray-900">
                                                            {formatCurrency(expense.amount)}
                                                        </div>
                                                        <div className="flex items-center gap-1 text-xs mt-1">
                                                            {isSynced ? (
                                                                <>
                                                                    <CheckCircle size={12} className="text-green-600" />
                                                                    <span className="text-green-600">Synced</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <AlertCircle size={12} className="text-orange-600" />
                                                                    <span className="text-orange-600">Needs validation</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Description and tags */}
                                                <div className="mb-3">
                                                    <div className="text-sm text-gray-600 mb-2">
                                                        {expense.nature_of_expenses}
                                                    </div>
                                                    <div className="flex flex-wrap gap-1">
                                                        {expense.is_itemized && (
                                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                                <Calculator size={8} className="mr-1" />
                                                                Itemized
                                                            </span>
                                                        )}
                                                        {expense.has_bank_info && (
                                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                                {expense.bank_display_name}
                                                            </span>
                                                        )}
                                                        {isSynced && (
                                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                                                <CheckCircle className="mr-1" size={8} />
                                                                Synced as {expense.sync_status}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Payment mode */}
                                                <div className="mb-3">
                                                    <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg ${paymentDisplay.bgColor}`}>
                                                        <PaymentIcon className={paymentDisplay.color} size={16} />
                                                        <div className="text-sm">
                                                            <div className="font-medium text-gray-900">
                                                                {paymentDisplay.label}
                                                            </div>
                                                            <div className={`text-xs font-medium ${paymentDisplay.color}`}>
                                                                Will sync as {paymentDisplay.syncAs}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* AI suggestions preview */}
                                                {expense.suggested_line_items && expense.suggested_line_items.length > 0 && (
                                                    <div className="mb-3 bg-purple-50 p-2 rounded border border-purple-200">
                                                        <div className="flex items-center gap-1 mb-1">
                                                            <Brain className="text-purple-600" size={12} />
                                                            <span className="text-xs font-medium text-purple-700">
                                                                {expense.suggested_line_items.length} AI Suggestions
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Approval status */}
                                                {expense.approval_info && (
                                                    <div className="mb-3">
                                                        {getApprovalStatusDisplay(expense)}
                                                    </div>
                                                )}

                                                {/* Action button */}
                                                <div className="flex justify-end">
                                                    {(expense.approvalinfo?.status !== 'approved' && expense.approvalinfo?.status !== null && expense.approvalinfo?.status !== undefined) ? (
                                                        <button
                                                            disabled
                                                            className="text-gray-400 cursor-not-allowed flex items-center gap-2 px-3 py-2 rounded-md"
                                                            title={`Cannot sync: ${expense.approvalinfo?.status === 'pending_approval'
                                                                    ? 'Pending approval'
                                                                    : expense.approvalinfo?.status === 'rejected'
                                                                        ? 'Rejected'
                                                                        : 'Not approved'
                                                                }`}
                                                        >
                                                            <AlertCircle size={16} />
                                                            {expense.approvalinfo?.status === 'pending_approval'
                                                                ? 'Pending Approval'
                                                                : expense.approvalinfo?.status === 'rejected'
                                                                    ? 'Rejected'
                                                                    : 'Not Approved'}
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleEditExpense(expense)}
                                                            disabled={!isOnline}
                                                            className="bg-purple-600 hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed text-white px-4 py-2 rounded-md flex items-center gap-2"
                                                        >
                                                            <Edit2 size={16} />
                                                            {expense.aisuggestions?.expenseaccount && <Brain size={14} className="text-purple-200" />}
                                                            Validate & Sync
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Pagination */}
                    {pagination.totalPages > 1 && (
                        <div className="p-4 sm:p-6 border-t flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                            <div className="text-sm text-gray-700">
                                Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
                                {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
                            </div>
                            <div className="flex gap-2 justify-center sm:justify-end">
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                                    disabled={pagination.page === 1 || !isOnline}
                                    className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                                >
                                    Previous
                                </button>
                                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm">
                                    {pagination.page} / {pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                                    disabled={pagination.page === pagination.totalPages || !isOnline}
                                    className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* ENHANCED EDIT MODAL with AI Validation and Line Items */}
                {showEditModal && editingExpense && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[95vh] overflow-y-auto">
                            {/* Header */}
                            <div className="sticky top-0 bg-white border-b px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 z-10">
                                <div className="flex flex-wrap items-center gap-2">
                                    <h2 className="text-lg sm:text-xl font-semibold flex items-center gap-2">
                                        <Brain className="text-purple-600" size={20} />
                                        Validate Expense - ID: {editingExpense.id}
                                    </h2>
                                    <div className="flex flex-wrap gap-2">
                                        {editForm.is_cash_payment && (
                                            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs flex items-center gap-1">
                                                <User size={12} />
                                                Cash → Bill
                                            </span>
                                        )}
                                        {!editForm.is_cash_payment && (
                                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs flex items-center gap-1">
                                                <CreditCard size={12} />
                                                Bank → Expense
                                            </span>
                                        )}
                                        <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs flex items-center gap-1">
                                            <Calculator size={12} />
                                            {editForm.line_items.length} Line Items
                                        </span>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setShowEditModal(false)}
                                    className="text-gray-400 hover:text-gray-600 transition-colors self-end sm:self-center"
                                    disabled={syncInProgress}
                                >
                                    <X size={24} />
                                </button>
                            </div>

                            <div className="p-4 sm:p-6 space-y-4 sm:space-y-6 relative">
                                {syncInProgress && <LoadingOverlay message="Syncing expense with AI validation..." />}

                                {/* Approval Status Banner */}
                                {editingExpense && editingExpense.approvalinfo && (
                                    <div className={`p-4 rounded-lg border ${editingExpense.approvalinfo?.status === 'approved'
                                        ? 'bg-green-50 border-green-200'
                                        : editingExpense.approvalinfo?.status === 'pending_approval'
                                            ? 'bg-orange-50 border-orange-200'
                                            : editingExpense.approvalinfo?.status === 'rejected'
                                                ? 'bg-red-50 border-red-200'
                                                : 'bg-gray-50 border-gray-200'
                                        }`}>
                                        <h3 className={`text-lg font-medium mb-2 flex items-center gap-2 ${editingExpense.approvalinfo?.status === 'approved'
                                            ? 'text-green-900'
                                            : editingExpense.approvalinfo?.status === 'pending_approval'
                                                ? 'text-orange-900'
                                                : editingExpense.approvalinfo?.status === 'rejected'
                                                    ? 'text-red-900'
                                                    : 'text-gray-900'
                                            }`}>
                                            {editingExpense.approvalinfo?.status === 'approved' ? (
                                                <CheckCircle className="text-green-600" size={18} />
                                            ) : editingExpense.approvalinfo?.status === 'pending_approval' ? (
                                                <AlertCircle className="text-orange-600" size={18} />
                                            ) : editingExpense.approvalinfo?.status === 'rejected' ? (
                                                <XCircle className="text-red-600" size={18} />
                                            ) : null}
                                            Approval Status: {editingExpense.approvalinfo?.status?.replace('_', ' ').toUpperCase() || 'UNKNOWN'}
                                        </h3>

                                        {editingExpense.approvalinfo?.status === 'approved' && (
                                            <div className="text-sm text-green-700">
                                                This expense has been approved and can be synced to Zoho Books.
                                                {editingExpense.approvalinfo?.approved_by && (
                                                    <div>Approved by: {editingExpense.approvalinfo.approved_by}</div>
                                                )}
                                            </div>
                                        )}

                                        {editingExpense.approvalinfo?.status === 'pending_approval' && (
                                            <div className="text-sm text-orange-700">
                                                This expense is pending approval.
                                                {editingExpense.approvalinfo?.approved_by && (
                                                    <div>Please contact approver: {editingExpense.approvalinfo.approved_by}</div>
                                                )}
                                            </div>
                                        )}

                                        {editingExpense.approvalinfo?.status === 'rejected' && (
                                            <div className="text-sm text-red-700">
                                                This expense has been rejected and cannot be synced to Zoho Books.
                                                {editingExpense.approvalinfo?.rejection_reason && (
                                                    <div className="mt-1">
                                                        <strong>Reason:</strong> {editingExpense.approvalinfo.rejection_reason}
                                                    </div>
                                                )}
                                                {editingExpense.approvalinfo?.approved_by && (
                                                    <div>Rejected by: {editingExpense.approvalinfo.approved_by}</div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* AI Suggestions Summary */}
                                {editForm.ai_suggestions && (
                                    <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                                        <h3 className="text-lg font-medium text-purple-900 mb-3 flex items-center gap-2">
                                            <Brain className="text-purple-600" size={18} />
                                            AI Suggestions Applied
                                        </h3>

                                        {/* Line Item Suggestions Summary */}
                                        {editForm.line_items.some(item => item.ai_suggested) && (
                                            <div className="mb-4">
                                                <h4 className="text-md font-medium text-purple-800 mb-2">Expense Account Suggestions:</h4>
                                                <div className="grid grid-cols-1 gap-2">
                                                    {editForm.line_items.filter(item => item.ai_suggested).map((item, index) => (
                                                        <div key={item.id} className="bg-white p-2 rounded border text-sm">
                                                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                                                                <div className="flex items-center gap-2">
                                                                    <Target className="text-purple-600 flex-shrink-0" size={12} />
                                                                    <span className="font-medium">{item.description}:</span>
                                                                    <span className="text-gray-600 truncate">{item.suggested_account_name}</span>
                                                                </div>
                                                                <div className="flex items-center gap-2">
                                                                    <span className="text-purple-600 text-xs">
                                                                        {Math.round(item.ai_confidence * 100)}% confidence
                                                                    </span>
                                                                    <span className="font-medium text-green-600">
                                                                        {formatCurrency(item.amount)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Payment Account Suggestion */}
                                        {editForm.ai_suggestions.payment_account && !editForm.is_cash_payment && (
                                            <div className="bg-white p-3 rounded border">
                                                <div className="flex items-center gap-2 mb-2">
                                                    {editForm.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
                                                        <CheckCircle className="text-green-600" size={16} />
                                                    ) : (
                                                        <AlertTriangle className="text-orange-600" size={16} />
                                                    )}
                                                    <span className="font-medium text-blue-800">Payment Account</span>
                                                </div>
                                                {editForm.ai_suggestions.payment_account.validation_status === 'confirmed' ? (
                                                    <>
                                                        <div className="text-sm text-gray-700">
                                                            {editForm.ai_suggestions.payment_account.account_name}
                                                        </div>
                                                        <div className="text-xs text-blue-600 font-medium">
                                                            {Math.round(editForm.ai_suggestions.payment_account.confidence * 100)}% match confirmed
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="space-y-1">
                                                        <div className="text-sm text-orange-700 font-medium">
                                                            Requires Confirmation
                                                        </div>
                                                        <div className="text-xs text-orange-600">
                                                            {editForm.ai_suggestions.payment_account.message}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Employee Details for Cash Payments */}
                                {editForm.is_cash_payment && editForm.employee_details && (
                                    <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                        <h3 className="text-lg font-medium text-green-900 mb-3 flex items-center gap-2">
                                            <User className="text-green-600" size={18} />
                                            Employee Vendor Details (Auto-created)
                                        </h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <div>
                                                <span className="text-sm font-medium text-green-800">Name:</span>
                                                <div className="text-gray-700">{editForm.employee_details.name}</div>
                                            </div>
                                            <div>
                                                <span className="text-sm font-medium text-green-800">Email:</span>
                                                <div className="text-gray-700 break-all">{editForm.employee_details.email}</div>
                                            </div>
                                            <div>
                                                <span className="text-sm font-medium text-green-800">Phone:</span>
                                                <div className="text-gray-700">{editForm.employee_details.phone}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Enhanced Basic Information */}
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <h3 className="text-lg font-medium text-gray-900 mb-4">Basic Information</h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Date *
                                            </label>
                                            <input
                                                type="date"
                                                value={editForm.date}
                                                onChange={(e) => setEditForm(prev => ({ ...prev, date: e.target.value }))}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                disabled={syncInProgress}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Description
                                            </label>
                                            <input
                                                type="text"
                                                value={editForm.nature_of_expenses}
                                                onChange={(e) => setEditForm(prev => ({ ...prev, nature_of_expenses: e.target.value }))}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                placeholder="Expense description"
                                                disabled={syncInProgress}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Total Amount (Calculated)
                                            </label>
                                            <div className="flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-md">
                                                <Calculator className="text-green-600" size={16} />
                                                <span className="text-lg font-bold text-green-700">
                                                    {formatCurrency(calculateTotalAmount())}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ENHANCED: Line Items Section with Add/Remove */}
                                <div className="bg-white border border-gray-200 rounded-lg">
                                    <div className="border-b border-gray-200 p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                                        <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                                            <Calculator className="text-blue-600" size={18} />
                                            Line Items ({editForm.line_items.length} items)
                                        </h3>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={handleManualAISuggestion}
                                                disabled={loading || syncInProgress || !isOnline}
                                                className="px-3 py-1 bg-purple-600 text-white text-sm rounded-md hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                                            >
                                                <Brain size={14} />
                                                {loading ? 'Getting AI Suggestions...' : 'AI Suggest Accounts'}
                                            </button>
                                            <button
                                                onClick={addLineItem}
                                                disabled={syncInProgress}
                                                className="px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                                            >
                                                <Plus size={14} />
                                                Add Item
                                            </button>
                                        </div>
                                    </div>

                                    <div className="p-4 space-y-4">
                                        {editForm.line_items.map((item, index) => (
                                            <div key={item.id} className="bg-gray-50 p-4 border rounded-lg">
                                                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3 gap-2">
                                                    <div className="flex flex-wrap items-center gap-2">
                                                        <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                                                            Item {index + 1}
                                                        </span>
                                                        {getAISuggestionIndicator(item)}
                                                        {item.manually_selected && (
                                                            <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
                                                                Manual Override
                                                            </span>
                                                        )}
                                                    </div>
                                                    {editForm.line_items.length > 1 && (
                                                        <button
                                                            onClick={() => removeLineItem(index)}
                                                            disabled={syncInProgress}
                                                            className="text-red-600 hover:text-red-800 p-1 disabled:opacity-50"
                                                            title="Remove this line item"
                                                        >
                                                            <Trash2 size={16} />
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="grid grid-cols-1 lg:grid-cols-12 gap-3">
                                                    <div className="lg:col-span-5">
                                                        <label className="block text-xs font-medium text-gray-700 mb-1">
                                                            Description *
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={item.description}
                                                            onChange={(e) => handleLineItemChange(index, 'description', e.target.value)}
                                                            className="w-full px-2 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            placeholder="Enter description"
                                                            required
                                                            disabled={syncInProgress}
                                                        />
                                                        {item.original_text && (
                                                            <div className="text-xs text-gray-500 mt-1 italic">
                                                                Original: {item.original_text}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="lg:col-span-2">
                                                        <label className="block text-xs font-medium text-gray-700 mb-1">
                                                            Amount *
                                                        </label>
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            min="0"
                                                            value={item.amount}
                                                            onChange={(e) => handleLineItemChange(index, 'amount', parseFloat(e.target.value) || 0)}
                                                            className="w-full px-2 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            placeholder="0.00"
                                                            required
                                                            disabled={syncInProgress}
                                                        />
                                                    </div>

                                                    <div className="lg:col-span-5">
                                                        <label className="block text-xs font-medium text-gray-700 mb-1">
                                                            Expense Account *
                                                            {item.ai_suggested && item.ai_confidence > 0 && (
                                                                <span className="text-purple-600 text-xs ml-1">
                                                                    (AI: {Math.round(item.ai_confidence * 100)}%)
                                                                </span>
                                                            )}
                                                        </label>
                                                        <select
                                                            value={item.account_id || ''}
                                                            onChange={(e) => handleLineItemAccountChange(index, e.target.value)}
                                                            className="w-full px-2 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            required
                                                            disabled={syncInProgress}
                                                        >
                                                            <option value="">Select account</option>
                                                            {editForm.config_options?.expense_accounts?.map(account => (
                                                                <option key={account.account_id} value={account.account_id}>
                                                                    {account.account_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {item.suggested_account_name && (
                                                            <div className="text-xs text-purple-600 mt-1 flex items-center gap-1">
                                                                <Target size={10} />
                                                                AI Suggested: {item.suggested_account_name}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Configuration Section */}
                                <div className="bg-white border border-gray-200 rounded-lg">
                                    <div className="border-b border-gray-200 p-4">
                                        <h3 className="text-lg font-medium text-gray-900">Sync Configuration</h3>
                                    </div>

                                    <div className="p-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            {!editForm.is_cash_payment && (
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Payment Account *
                                                        {editForm.ai_suggestions?.payment_account?.validation_status === 'confirmed' && (
                                                            <span className="text-green-600 text-xs ml-1">(AI Matched)</span>
                                                        )}
                                                        {editForm.ai_suggestions?.payment_account?.validation_status === 'requires_confirmation' && (
                                                            <span className="text-orange-600 text-xs ml-1">(Please Confirm)</span>
                                                        )}
                                                    </label>
                                                    <select
                                                        value={expenseSyncConfig.paid_through_account_id}
                                                        onChange={(e) => setExpenseSyncConfig(prev => ({
                                                            ...prev,
                                                            paid_through_account_id: e.target.value,
                                                            payment_account_id: e.target.value
                                                        }))}
                                                        className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                        required
                                                        disabled={syncInProgress}
                                                    >
                                                        <option value="">Select payment account</option>
                                                        {editForm.config_options?.payment_accounts?.map(account => (
                                                            <option key={account.account_id} value={account.account_id}>
                                                                {account.account_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {editForm.ai_suggestions?.payment_account?.validation_status === 'requires_confirmation' && (
                                                        <p className="text-xs text-orange-600 mt-1">
                                                            {editForm.ai_suggestions.payment_account.message}
                                                        </p>
                                                    )}
                                                </div>
                                            )}

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Reference Number
                                                </label>
                                                <input
                                                    type="text"
                                                    value={expenseSyncConfig.invoice_no}
                                                    onChange={(e) => setExpenseSyncConfig(prev => ({ ...prev, invoice_no: e.target.value }))}
                                                    placeholder={generateInvoiceNumber(editingExpense.id)}
                                                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    disabled={syncInProgress}
                                                />
                                            </div>

                                            <div className="sm:col-span-2">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Notes
                                                </label>
                                                <textarea
                                                    value={expenseSyncConfig.notes}
                                                    onChange={(e) => setExpenseSyncConfig(prev => ({ ...prev, notes: e.target.value }))}
                                                    rows={3}
                                                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    placeholder="Additional notes for this expense"
                                                    disabled={syncInProgress}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Footer Actions with Enhanced Summary */}
                            <div className="sticky bottom-0 bg-gray-50 px-4 sm:px-6 py-4 border-t">
                                {/* Summary Section */}
                                <div className="mb-4 p-3 bg-white rounded border">
                                    <h4 className="text-sm font-medium text-gray-900 mb-2">Sync Summary</h4>
                                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
                                        <div>
                                            <span className="text-gray-600">Total Amount:</span>
                                            <div className="font-bold text-green-600 text-base sm:text-lg">
                                                {formatCurrency(calculateTotalAmount())}
                                            </div>
                                        </div>
                                        <div>
                                            <span className="text-gray-600">Line Items:</span>
                                            <div className="font-medium text-blue-600">
                                                {editForm.line_items.length} item{editForm.line_items.length !== 1 ? 's' : ''}
                                            </div>
                                        </div>
                                        <div>
                                            <span className="text-gray-600">AI Suggestions:</span>
                                            <div className="font-medium text-purple-600">
                                                {editForm.line_items.filter(item => item.ai_suggested).length} / {editForm.line_items.length}
                                            </div>
                                        </div>
                                        <div>
                                            <span className="text-gray-600">Sync Type:</span>
                                            <div className={`font-medium ${editForm.is_cash_payment ? 'text-green-600' : 'text-blue-600'}`}>
                                                {editForm.is_cash_payment ? 'Bill (Cash)' : 'Expense (Bank)'}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Validation Messages */}
                                    <div className="mt-3 space-y-1">
                                        {editForm.is_cash_payment && editForm.employee_details && (
                                            <div className="text-sm text-green-600 font-medium flex items-center gap-1">
                                                <User size={14} />
                                                Employee vendor: {editForm.employee_details.name}
                                            </div>
                                        )}
                                        {editForm.ai_suggestions?.payment_account?.validation_status === 'requires_confirmation' && (
                                            <div className="text-sm text-orange-600 font-medium flex items-center gap-1">
                                                <AlertTriangle size={14} />
                                                Payment account needs confirmation
                                            </div>
                                        )}
                                        {editForm.line_items.some(item => !item.account_id) && (
                                            <div className="text-sm text-red-600 font-medium flex items-center gap-1">
                                                <AlertCircle size={14} />
                                                {editForm.line_items.filter(item => !item.account_id).length} line items missing expense accounts
                                            </div>
                                        )}
                                        {editForm.line_items.some(item => parseFloat(item.amount) <= 0) && (
                                            <div className="text-sm text-red-600 font-medium flex items-center gap-1">
                                                <AlertCircle size={14} />
                                                Some line items have zero or negative amounts
                                            </div>
                                        )}
                                        {!isOnline && (
                                            <div className="text-sm text-red-600 font-medium flex items-center gap-1">
                                                <WifiOff size={14} />
                                                You are offline. Cannot sync until connection is restored.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                                    <div className="text-sm text-gray-600">
                                        {editForm.line_items.filter(item => item.ai_suggested).length > 0 && (
                                            <span className="flex items-center gap-1">
                                                <Brain size={14} className="text-purple-500" />
                                                {editForm.line_items.filter(item => item.ai_suggested).length} AI suggestions applied
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex gap-3">
                                        <button
                                            onClick={() => {
                                                if (!syncInProgress) {
                                                    setShowEditModal(false);
                                                }
                                            }}
                                            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                            disabled={syncInProgress}
                                        >
                                            {syncInProgress ? 'Syncing...' : 'Cancel'}
                                        </button>
                                        <button
                                            onClick={handleSyncExpense}
                                            disabled={
                                                syncInProgress ||
                                                !isOnline ||
                                                calculateTotalAmount() <= 0 ||
                                                editForm.line_items.some(item => !item.account_id || !item.description.trim() || parseFloat(item.amount) <= 0) ||
                                                (!editForm.is_cash_payment && !expenseSyncConfig.paid_through_account_id)
                                            }
                                            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-colors"
                                        >
                                            <Upload size={16} />
                                            {syncInProgress ? (
                                                <>
                                                    <RefreshCw size={16} className="animate-spin" />
                                                    Syncing...
                                                </>
                                            ) : (
                                                <>
                                                    {editForm.is_cash_payment ? 'Sync as Bill' : 'Sync as Expense'}
                                                    <span className="hidden sm:inline text-xs bg-blue-500 px-2 py-1 rounded">
                                                        {editForm.line_items.length} items
                                                    </span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Enhanced Progress Indicator */}
                {syncInProgress && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
                            <div className="text-center">
                                <div className="flex justify-center mb-4">
                                    <div className="relative">
                                        <RefreshCw className="animate-spin text-blue-500" size={32} />
                                        <Brain className="absolute inset-0 text-purple-500" size={16} style={{ margin: '8px' }} />
                                    </div>
                                </div>
                                <h3 className="font-medium text-lg mb-2">AI-Powered Sync in Progress</h3>
                                <div className="space-y-2 text-sm text-gray-600">
                                    <p className="flex items-center justify-center gap-2">
                                        <Calculator size={14} />
                                        Processing {editForm.line_items.length} line items
                                    </p>
                                    <p>
                                        {editForm.is_cash_payment ? (
                                            <>
                                                <User size={14} className="inline mr-1" />
                                                Creating employee vendor and syncing as bill...
                                            </>
                                        ) : (
                                            <>
                                                <CreditCard size={14} className="inline mr-1" />
                                                Validating payment account and syncing as expense...
                                            </>
                                        )}
                                    </p>
                                    {editForm.line_items.filter(item => item.ai_suggested).length > 0 && (
                                        <p className="text-purple-600">
                                            <Brain size={14} className="inline mr-1" />
                                            Applying {editForm.line_items.filter(item => item.ai_suggested).length} AI suggestions
                                        </p>
                                    )}
                                </div>
                                <div className="mt-4">
                                    <div className="text-xs text-gray-500">
                                        This may take a few moments...
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DailySpendZohoIntegration;